/* eslint-disable react/prop-types */
import React, {
  useEffect,
  useRef,
  useState,
  useMemo,
} from 'react';
import {
  Button,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  message,
  Row,
  Space,
  Spin,
  Steps,
  Tooltip,
  Typography,
} from 'antd';
import {
  getCatalogoDePadrones,
  getTipoDePadronPorContenType,
  getContenTypePorTipoDePadron,
  getTiposDeCombustibles,
  getTiposDeTramitesVehiculares,
  getCatalogoDePaises,
  getMarcasDeMotocicletas,
  getUsosDeMotocicletas,
  getDocumentosDeRegularizacion,
  getEstados,
  getMarcasDeRemolques,
  getUsosDeRemolques,
} from 'api/catalogos';
import { getCiudadanoCaja, postImprimirOrdenDePago } from 'api/cuentaunicasir/index';
import { getContribuyente, getContribuyenteCaja } from 'api/empresas/contribuyentes';
import {
  getMotocicleta,
  getMotocicletaCaja,
  patchMotocicleta,
  postMotocicleta,
} from 'api/recaudacion/motocicletas';
import { InputSearchPro } from 'components/InputSearch';
import { useSelector } from 'react-redux';
import styled, { ThemeProvider } from 'styled-components';
import padronToString, { getNombreCompleto } from 'utils/padronesToString';
import BusquedaAvanzadaPadrones from 'views/Recaudacion/Caja/BusquedaAvanzadaPadrones';
import {
  getClasesDeVehiculos,
  getColoresVehiculos,
  getEstadosDeVehiculo,
  getLineasVehiculares,
  getMarcasDeVehiculos,
  getOrdenDePago,
  getPlacas,
  getServiciosDelVehiculo,
  getTiposDeMotocicletas,
  getTiposDeVehiculos,
  getVehiculoCaja,
  postConsultarCargosPorPadron,
  postGenerarCargos,
} from 'api/recaudacion';
import { getCargosVehiculares } from 'api/configuracion/cargosVehiculares';
import {
  ArrowLeftOutlined,
  ArrowRightOutlined,
  QuestionCircleOutlined,
  SaveOutlined,
  StopOutlined,
  HomeOutlined,
} from '@ant-design/icons';
import {
  capitalize,
  decimalNormalizer,
  INTEGER_PATTERN,
  listToString,
  toInteger,
  toMoment,
  toUpper,
  titleize,
  getDistinctValues,
  noSymbolsCapitalized,
} from 'utils/normalizers';
import NumericInput from 'components/NumericInput';
import { getVersionesVehiculares, getVersionVehicular } from 'api/catalogos/versionVehicular';
import Select from 'components/Select';
import { getTiposDeTenencias } from 'api/recaudacion/tiposDeTenencias';
import {
  postVehiculo,
  patchVehiculo,
  getVehiculo,
  getFormatoTramitePDF,
} from 'api/recaudacion/vehiculos';
import GlobalStyles from 'themes/global';
import {
  tiposDeTramitesReporteador,
  imprimirTarjetaDeCirculacionVehiculo,
} from 'components/Catalogos/ModalTipoTramite';
import { imprimirTarjetaDeCirculacionMoto } from 'components/Catalogos/ModalTarjetaMotos';
import Previewer from 'components/Previewer';
import { getTipoDeCargo } from 'api/recaudacion/tiposDeCargo';
import { getTramites, patchTramite, postTramite } from 'api/tramites/tramites';
import { getVariables } from 'api/configuracion/variables';
import {
  DATE_FORMAT,
  DATE_NETPAY_FORMAT,
  DATE_FRONTEND_FORMAT,
  TIME_FORMAT,
  formatReceived,
} from 'utils/formatValues';
import { getCargos } from 'api/recaudacion/cargos';
import { getPlantillaTramite } from 'api/tramites/plantillasDeTramites';
import { getCiudadano, getMessageConsiderado, patchCiudadano } from 'api/cuentaunicasir';
import ModalCancelarTramite from 'components/ModalCancelarTramite';
import { getUnidadesDeRecaudacion } from 'api/configuracion/unidadesDeRecaudacion';
import { useHistory } from 'react-router';
import { getReciboPDFDeTramite, getRecibos } from 'api/recaudacion/recibos';
import BusquedaAvanzadaVersion from 'components/BusquedaAvanzadaVersion';
import checkToken from 'api/utils/checkToken';
import { getDocumentosDeTramites } from 'api/empresas/documentosDeTramites';
import { getPeriodosFiscales } from 'api/catalogos/periodosFiscales';
import {
  postGetConfiguracionDeAsignacionDePlacas,
} from 'api/recaudacion/configuracionDeAsignacionDePlacas';
import { createDecimalRegExp, SLUG_PATTERN } from 'utils/patterns';
import { postObtenerReporte } from 'api/reporteador';
import WidgetPlaca, { saveOrLinkPlaca } from 'components/widgetPlaca';
import {
  getRemolque,
  getRemolqueCaja,
  patchRemolque,
  postRemolque,
} from 'api/recaudacion/remolque';
import { imprimirTarjetaDeCirculacionRemolque } from 'components/ModalTarjetaDeCirculacion';
import { TableAdeudoPadron, errorMessage, getTotalPadron } from 'views/Recaudacion/Caja/PanelPadron';
import { normalizeCargos } from 'store/reducers/caja';
import { recalculateCargos, sortCargos } from 'utils/cargos';
import round from 'utils/round';
import toCurrency from 'utils/toCurrency';
import { getTiposDeConsiderados } from 'api/cuentaunicasir/tipoDeConsiderado';
import { postPadronConsiderado } from 'api/cuentaunicasir/padronesConsiderados';
import UpdateCiudadano from 'components/UpdateCiudadano';
import moment from 'moment';
import WidgetServicioPublico from 'components/WidgetServicioPublico';
import { tiposDatosEnum } from 'views/Tramites/GPM/enums';
import { ActionsNames } from 'utils/permission';
import { modelsSearches } from 'utils/permission/models';
import WidgetRfcEmisor from 'components/WidgetRfcEmisor';

const mapId = (c) => c.id;
const listDisabledChargesRefrendoBaja = [5178];

export const permissionConfig = {
  mainPermission: 'view_tramites_vehiculares',
  required: [
    'view_tipodetramitevehicular',
    'view_plantilladetramite',
    'view_tramite',
    'add_tramite',
    'change_tramite',
    'view_ciudadano',
    'view_contribuyente',
    'change_ciudadano',
    'view_tipodeconsiderado',
    'add_padronconsiderado',
    'view_cargovehicular',
    'view_cargo',
    'view_recibo',
    'view_periodofiscal',
    'view_configuraciondeasignaciondeplacas',
    'view_estado',
  ],
  customActions: [
    {
      name: 'imprimir_orden_pago',
      title: 'Imprimir orden de pago',
      permissions: ['view_referenciadepago', 'add_referenciadepago'],
    },
    {
      name: 'generar_cargos',
      title: 'Generar cargos',
      permissions: [
        'view_tipodecargo',
        'view_tipodeaplicacionparacargo',
        'view_variable',
        'view_valorporvariabledeseleccion',
        'add_cargo',
      ],
    },
  ],
  customSections: [
    {
      name: 'tramites_vehiculo',
      title: 'Trámites vehículo',
      permissions: [
        'view_vehiculo',
        'add_vehiculo',
        'change_vehiculo',
        'view_marcadelvehiculo',
        'view_lineavehicular',
        'view_versionvehicular',
        'view_catalogodeversionamientovehicular',
        'view_usodelamotocicleta',
        'view_tipodevehiculo',
        'view_clasedelvehiculo',
        'view_tipodecombustiblevehicular',
        'view_catalogodecolorvehicular',
        'view_serviciodelvehiculo',
        'view_estadodelvehiculo',
        'view_clavededocumentoderegularizacion',
        'view_documentodetramite',
        'view_catalogodepais',

        'view_tipodetenenciavehicular', // no esta en form
      ],
    },
    {
      name: 'tramites_motocicleta',
      title: 'Trámites motocicleta',
      permissions: [
        'view_motocicleta',
        'add_motocicleta',
        'change_motocicleta',
        'view_unidadderecaudacion',
        'view_tipodetramitevehicular',
        'view_catalogodepais',
        'view_usodelamotocicleta',
        'view_marcademotocicleta',
        'view_estadodelvehiculo',
        'view_serviciodelvehiculo',
        'view_catalogodecolorvehicular',
      ],
    },
    {
      name: 'tramites_remolque',
      title: 'Trámites remolque',
      permissions: [
        'view_remolque',
        'add_remolque',
        'change_remolque',
        'view_unidadderecaudacion',
        'view_catalogodepais',
        'view_marcademotocicleta',
        'view_lineavehicular',
        'view_estadodelvehiculo',
        'view_serviciodelvehiculo',
        'view_catalogodecolorvehicular',
        'view_usodelremolque',
      ],
    },
    {
      name: 'alta_padrones',
      title: 'Alta de padrones',
      models: [
        'ciudadano',
        'contribuyente',
        'vehiculo',
        'motocicleta',
        'remolque',
      ],
      action: ActionsNames.add,
    },
    {
      name: 'busquedas_avanzadas_padrones',
      title: 'Búsquedas avanzadas padrones',
      models: [
        ...modelsSearches.ciudadano,
        ...modelsSearches.vehiculo,
      ],
      action: ActionsNames.view,
    },
  ],
};

const TramitesVehiculares = ({ useAutoAssing }) => {
  const history = useHistory();
  const [form] = Form.useForm();
  const marca = Form.useWatch('marca', form);
  const esNacional = Form.useWatch('es_vehiculo_nacional', form);
  const cantidadDePlacas = Form.useWatch('cantidad_de_placas', form);
  const permitirPlacaDuplicada = Form.useWatch('permitirPlacaDuplicada', form);
  const permitirPlacaManual = Form.useWatch('permiteplacamanual', form);
  const { theme } = useSelector(({ app }) => app);
  const padrones = useSelector(({ catalogs }) => catalogs.padrones);
  const padronesPropietarios = [1, 15].map((e) => padrones.find((p) => p.id === e));
  const padronesVehiculares = [4, 16, 17]
    .map((e) => padrones.find((p) => p.id === e)).filter((e) => e);
  const [esPlacaDuplicada, setEsPlacaDuplicada] = useState(false);
  const [loading, setLoading] = useState(true);
  const [loadingAdeudo, setLoadingAdeudo] = useState(false);
  const [visibleCancelar, setVisibleCancelar] = useState(false);
  const [tiposDeTramites, setTiposDeTramites] = useState([]);
  const [tipoDeTramite, setTipoDeTramite] = useState();
  const [currentStep, setCurrentStep] = useState(0);
  const [visibleBusquedaPropietario, setVisibleBusquedaPropietario] = useState(false);
  const [visibleBusquedaPropietarioNuevo, setVisibleBusquedaPropietarioNuevo] = useState(false);
  const [visibleBusquedaVehiculo, setVisibleBusquedaVehiculo] = useState(false);
  const [propietario, setPropietario] = useState();
  const [propietarioNuevo, setPropietarioNuevo] = useState();
  const [vehiculo, setVehiculo] = useState();
  const [tramite, setTramite] = useState();
  const [tipoDePadronPropietario, setTipoDePadronPropietario] = useState(1);
  const [tipoDePadronPropietarioNuevo, setTipoDePadronPropietarioNuevo] = useState(1);
  const [tipoDePadronVehicular, setTipoDePadronVehicular] = useState(4);
  const [tipoDePadronFilter, setTipoDePadronFilter] = useState(null);
  const [visiblePreview, setVisiblePreview] = useState();
  const base64 = useRef({});
  const [variables, setVariables] = useState([]);
  const [selectedKeys, setSelectedKeys] = useState([]);
  const paises = useRef({ results: [] });
  const [tiposDeConsiderado, setTiposDeConsiderado] = useState([]);
  const [ordenPagada, setOrdenPagada] = useState();
  const moneda = useSelector(({ auth }) => auth.entidad.moneda);
  const [decimalRegExp] = createDecimalRegExp(moneda);

  // Catalogos formulario
  const marcas = useRef({ results: [] });
  const lineas = useRef({ results: [] });
  const [marcasTemp, setMarcasTemp] = useState({ results: [] });
  const [lineasTemp, setLineasTemp] = useState({ results: [] });
  const [configsAsigPlacas, setConfigsAsigPlacas] = useState([]);
  const [tipoDeVehiculo, setTipoDeVehiculo] = useState([]);
  const [claseDelVehiculo, setClaseDelVehiculo] = useState([]);
  const [tipoDeCombustible, setTipoDeCombustible] = useState([]);
  const [colores, setColores] = useState([]);
  const [estadosDelVehiculo, setEstadoDelVehiculo] = useState([]);
  const [tenencias, setTenencias] = useState([]);
  const [unidadesDeRecaudacion, setUnidadesDeRecaudacion] = useState([]);
  const [servicios, setServicios] = useState([]);
  const [usos, setUsos] = useState([]);
  const [cargosGenerados, setCargosGenerados] = useState([]);
  const [versionFound, setVersionFound] = useState();
  const [dataExternoVersiones, setDataExternoVersiones] = useState({ results: [] });
  const [visibleBusquedaVersiones, setVisibleBusquedaVersiones] = useState(false);
  const [documentoTramite, setDocumentoTramite] = useState([]);
  const [clavesDeDocumento, setClavesDeDocumento] = useState([]);
  const [periodosFiscales, setPeriodosFiscales] = useState([]);
  const [estados, setEstados] = useState([]);
  const [periodosSeleccionados, setPeriodosSeleccionados] = useState([]);
  const [usosRemolques, setUsosRemolques] = useState([]);
  const [visiblePlaca, setVisiblePlaca] = useState(false);
  const [visibleWidget, setVisibleWidget] = useState(false);
  const [visibleWidgetRFC, setVisibleWidgetRFC] = useState(false);
  const [cargosAdeudo, setCargosAdeudo] = useState([]);
  const [_messageAdeudo, setMessageAdeudo] = useState();
  const [esConsiderado, setEsConsiderado] = useState(false);
  const [tipoDeConsiderado, setTipoDeConsiderado] = useState();
  const [visibleUpdateData, setVisibleUpdateData] = useState(false);
  const [folioRepuve, setFolioRepuve] = useState(null);
  const [tiposDeMotocicletas, setTiposDeMotocicletas] = useState([]);

  // Banderas para el estado del tramite
  const tramiteEnProceso = tramite?.estados_globales === 2;
  const tramiteFinalizado = tramite?.estados_globales === 4;

  const MAP_IDS_POR_TIPO_DE_TRAMITE = useMemo(() => {
    let _tiposDeTramites = [...tiposDeTramites];
    const REFRENDO = _tiposDeTramites.filter((e) => /^(SAF-DRI-03)(4|5|6|7|8|9)$/.test(e?.plantilla_de_tramites?.homoclave))
      .map(mapId);
    _tiposDeTramites = _tiposDeTramites.filter((e) => !REFRENDO.includes(e.id));
    const ALTA = _tiposDeTramites
      .filter((e) => /alta/i.test(e.descripcion)).map(mapId);
    _tiposDeTramites = _tiposDeTramites.filter((e) => !ALTA.includes(e.id));

    const BAJA = _tiposDeTramites
      .filter((e) => /baja/i.test(e.descripcion)).map(mapId);
    _tiposDeTramites = _tiposDeTramites.filter((e) => !BAJA.includes(e.id));
    const CAMBIO = _tiposDeTramites
      .filter((e) => /cambio/i.test(e.descripcion)).map(mapId);
    return {
      ALTA,
      BAJA,
      CAMBIO,
      REFRENDO,
    };
  }, [tiposDeTramites]);

  const IDS_TRAMITES_SOPORTADOS = Object.keys(MAP_IDS_POR_TIPO_DE_TRAMITE)
    .map((t) => MAP_IDS_POR_TIPO_DE_TRAMITE[t]).flat();

  const IDS_TRAMITES = tiposDeTramites.map(mapId);
  const searchMethods = [
    {
      id: 1,
      descripcion: 'Referencia',
    },
    {
      id: 2,
      descripcion: 'Recibo',
    },
  ];

  const isAlta = MAP_IDS_POR_TIPO_DE_TRAMITE.ALTA.includes(tipoDeTramite?.id);
  const isBaja = MAP_IDS_POR_TIPO_DE_TRAMITE.BAJA.includes(tipoDeTramite?.id);
  const isCambio = MAP_IDS_POR_TIPO_DE_TRAMITE.CAMBIO.includes(tipoDeTramite?.id);
  const isRefrendo = MAP_IDS_POR_TIPO_DE_TRAMITE.REFRENDO.includes(tipoDeTramite?.id);
  const isRemolque = [17].includes(tipoDePadronVehicular);
  const isVehiculo = [4].includes(tipoDePadronVehicular);
  const isMoto = [16].includes(tipoDePadronVehicular);
  const isDotacionDePlacas = (tipoDeTramite?.id === 44);
  const isBajaDelEstadoVehiculo = (tipoDeTramite?.id === 2);
  const isDecreto = [56, 57, 58, 59, 60, 66].includes(tipoDeTramite?.id);
  const isServicioPublico = [45, 46, 47, 48, 49, 50, 55].includes(tipoDeTramite?.id);

  const isRefrendoPeriodoActual = isRefrendo && tipoDeTramite.plantilla_de_tramites.homoclave === 'SAF-DRI-034' && ((isVehiculo && !isServicioPublico) || (isMoto && !isServicioPublico));
  const isRefrendoPeriodoActualManual = isRefrendo && tipoDeTramite.plantilla_de_tramites.homoclave === 'SAF-DRI-034' && (isServicioPublico || isRemolque);
  const isRefrendoBaja = isRefrendo && tipoDeTramite.plantilla_de_tramites.homoclave === 'SAF-DRI-035';
  const isRefrendoReemplacamiento = isRefrendo && tipoDeTramite.plantilla_de_tramites.homoclave === 'SAF-DRI-036';
  const isRefrendoReemplacamientoManual = isRefrendo && tipoDeTramite.plantilla_de_tramites.homoclave === 'SAF-DRI-037';
  const tramitePortal = isRefrendo && tipoDeTramite.plantilla_de_tramites.homoclave === 'SAF-DRI-038';
  const tramitePortalReemplacamiento = isRefrendo && tipoDeTramite.plantilla_de_tramites.homoclave === 'SAF-DRI-039';

  const VISIBLE_PREVIEW_ENUM = {
    RECIBO: 'RECIBO',
    ORDEN_DE_PAGO: 'ORDEN_DE_PAGO',
    FORMATO_ALTA: 'FORMATO_ALTA',
    TARJETA_DE_CIRCULACION: 'TARJETA_DE_CIRCULACION',
    FORMATO_BAJA: 'FORMATO_BAJA',
  };

  const padronVehicularLabel = padrones.find((e) => e.id === tipoDePadronVehicular)
    ?.descripcion;

  useEffect(() => {
    let mounted = true;
    const fetchData = async () => {
      setLoading(true);
      await checkToken();
      const [
        _tiposDeTramites,
        _cargosVehiculares,
        _tipos,
        _clases,
        _tiposDeCombustible,
        _coloresVehiculos,
        _servicios,
        _estadosDelVehiculo,
        _tenencias,
        _variables,
        _unidadesDeRecaudacion,
        _usos,
        _documentosDeRegularizacion,
        _documentosTramites,
        _periodosFiscales,
        _estados,
        _usoRemolques,
        _tipoDeConsiderados,
        _tiposDeMoto,
      ] = await Promise.all([
        getTiposDeTramitesVehiculares(),
        getCargosVehiculares(),
        getTiposDeVehiculos(),
        getClasesDeVehiculos(),
        getTiposDeCombustibles(),
        getColoresVehiculos(),
        getServiciosDelVehiculo(),
        getEstadosDeVehiculo(),
        getTiposDeTenencias(),
        getVariables({ es_script: true }),
        getUnidadesDeRecaudacion(),
        getUsosDeMotocicletas(),
        getDocumentosDeRegularizacion(),
        getDocumentosDeTramites(),
        getPeriodosFiscales(),
        getEstados(),
        getUsosDeRemolques(),
        getTiposDeConsiderados(),
        getTiposDeMotocicletas(),
        getCatalogoDePadrones(),
      ]);
      const _plantillasDeTramitesIds = _tiposDeTramites
        .map((e) => e.plantilla_de_tramites).filter((e) => e);
      const plantillasDeTramites = await Promise
        .all(_plantillasDeTramitesIds.map((e) => getPlantillaTramite(e)));
      const idsTiposDeCargo = [...new Set(_cargosVehiculares.map((e) => e.tipo_de_cargo).flat())];
      await checkToken();
      const _tiposDeCargos = idsTiposDeCargo.length ? await Promise.all(
        idsTiposDeCargo.map((e) => getTipoDeCargo(e)),
      ) : [];
      if (mounted) {
        const _tiposTramites = _tiposDeTramites
          .map((tt) => {
            const config = _cargosVehiculares.find((c) => c.tipo_de_tramite_vehicular === tt.id);
            const tiposDeCargos = config?.tipo_de_cargo
              .map((c) => _tiposDeCargos.find((e) => e.id === c))
              .sort((a, b) => _periodosFiscales.find((p) => p.id === b.periodo_fiscal).periodo
                - _periodosFiscales.find((p) => p.id === a.periodo_fiscal).periodo) || [];
            return ({
              ...tt,
              tiposDeCargos,
              plantilla_de_tramites: plantillasDeTramites
                .find((e) => e.id === tt.plantilla_de_tramites),
            });
          });
        setTiposDeTramites(_tiposTramites);
        setTipoDeVehiculo(_tipos);
        setClaseDelVehiculo(_clases);
        setTipoDeCombustible(_tiposDeCombustible);
        setColores(_coloresVehiculos);
        setServicios(_servicios);
        setEstadoDelVehiculo(_estadosDelVehiculo);
        setTenencias(_tenencias);
        setVariables(_variables);
        setUnidadesDeRecaudacion(_unidadesDeRecaudacion);
        setUsos(_usos);
        setClavesDeDocumento(_documentosDeRegularizacion);
        setDocumentoTramite(_documentosTramites);
        setPeriodosFiscales(_periodosFiscales);
        setEstados(_estados);
        setUsosRemolques(_usoRemolques);
        setTiposDeConsiderado(_tipoDeConsiderados);
        setTiposDeMotocicletas(_tiposDeMoto);
        setLoading(false);
      }
    };
    fetchData();
    return () => {
      mounted = false;
    };
  }, []);

  const gettersPadronesMap = {
    1: getCiudadanoCaja,
    4: getVehiculoCaja,
    15: getContribuyenteCaja,
    16: getMotocicletaCaja,
    17: getRemolqueCaja,
  };
  const validateTramiteEnProceso = async (_padron, _tipoDePadron, callback) => {
    const esCambio = MAP_IDS_POR_TIPO_DE_TRAMITE.CAMBIO.includes(tipoDeTramite.id);
    const _propietarioActual = _padron.propietario?.id
    || _padron.contribuyente_propietario?.id
    || _padron.contribuyente_propietario;
    const _tipoDePropietarioActual = _padron.propietario ? 1 : 15;
    const propietarioNuevoDiferente = !esCambio
      || _tipoDePropietarioActual !== tipoDePadronPropietarioNuevo
      || _propietarioActual !== propietarioNuevo?.id;

    if (isAlta && _propietarioActual !== propietario?.id) {
      message.info('El Vehículo no pertenece al solicitante');
    }
    if (propietarioNuevoDiferente) {
      if (!tramitePortal || !tramitePortalReemplacamiento) {
        const [_tramite] = await getTramites({
          content_type_a_padron: getContenTypePorTipoDePadron(_tipoDePadron),
          object_id_padron: _padron.id,
          estados_globales: 2,
          plantilla: tipoDeTramite.plantilla_de_tramites.id,
        });
        if (_tramite) {
          message.info(`Ya se encuentra en proceso otro trámite con este padrón (${_tramite.folio})`, 10);
        } else {
          callback();
        }
      } else {
        const [_tramite] = await getTramites({
          content_type_a_padron: getContenTypePorTipoDePadron(_tipoDePadron),
          object_id_padron: _padron.id,
          estados_globales: 2,
        });
        if (_tramite) {
          message.info(`Este folio ya se encuentra ligado al tramite (${_tramite.descripcion} - ${_tramite.folio}) favor de seleccionar la opción correcta.`, 10);
        } else {
          callback();
        }
      }
    } else {
      message.info('El propietario nuevo no puede ser el propietario anterior');
    }
  };

  const searchPadron = async (setter, propName, qName, tipoDePadron, callback) => {
    setLoading(true);
    const q = form.getFieldValue(qName);
    if (q) {
      const matches = await gettersPadronesMap[tipoDePadron]({ q }, false);
      if (matches.length || matches.count) {
        if ((matches.length || matches.count) === 1) {
          const [_padronFound] = (matches.results || matches);
          await validateTramiteEnProceso(_padronFound, tipoDePadron, () => {
            setter(_padronFound);
            form.setFieldsValue({ [propName]: _padronFound.id });
            if (callback) {
              callback(_padronFound);
            }
          });
        } else {
          message.warn('Ingrese una búsqueda más específica');
        }
      } else {
        message.warn('No se encontró el padrón');
      }
    }
    setLoading(false);
  };

  const required = { required: true };
  const validarPlacaDuplicada = async (callback) => {
    // if (!useAutoAssing) {
    const value = form.getFieldValue('numero_de_placa_vigente');
    const altValue = form.getFieldValue('placa');
    if ((value && !permitirPlacaDuplicada) || (altValue && !permitirPlacaDuplicada)) {
      setLoading(true);
      if (tipoDePadronVehicular !== 17) {
        const matches = await gettersPadronesMap[tipoDePadronVehicular]({
          numero_de_placa_vigente: value,
        });
        const [match] = (matches.results || matches)
          .filter((e) => e.numero_de_placa_vigente?.toLowerCase() === value?.toLowerCase());
        setEsPlacaDuplicada(Boolean(match));
        form.validateFields(['numero_de_placa_vigente']);
        if (!match) {
          callback();
        } else {
          message.info(`La placa del vehículo pertenece al vehiculo con la serie ${match?.numero_de_identificacion_vehicular}`, 5);
        }
      } else {
        const matches = await gettersPadronesMap[tipoDePadronVehicular]({
          placa: altValue,
        });
        const [match] = (matches?.results || matches)
          .filter((e) => e.placa?.toLowerCase() === altValue?.toLowerCase());
        setEsPlacaDuplicada(Boolean(match));
        form.validateFields(['placa']);
        if (!match) {
          callback();
        } else {
          message.info(`La placa del vehículo pertenece al Remolque con la serie ${match?.numero_de_identificacion_vehicular || match?.serie}`, 5);
        }
      }
      // }
      setLoading(false);
    }
  };

  const rules = {
    required: [required],
    integer: [
      required,
      {
        pattern: INTEGER_PATTERN,
        message: 'Ingrese un entero',
      },
    ],
    decimal: [
      required,
      {
        pattern: decimalRegExp,
        message: 'Ingrese un decimal válido',
      },
    ],
    numero_de_placa_vigente: [
      { required: true },
      {
        validator: async () => {
          if (esPlacaDuplicada && !permitirPlacaDuplicada && !useAutoAssing) {
            throw new Error(`Ya existe un ${padronVehicularLabel} con esta placa`);
          }
        },
      },
    ],
    slug: [
      {
        pattern: SLUG_PATTERN,
        message: 'Ingrese un valor correcto',
      },
    ],
  };

  const onCancel = () => {
    setOrdenPagada();
    setTipoDeTramite();
    form.resetFields();
    setPropietario();
    setPropietarioNuevo();
    setVehiculo();
    setTipoDePadronPropietario(1);
    setTipoDePadronVehicular(4);
    setTipoDePadronPropietarioNuevo(1);
    setCurrentStep(0);
    setTramite();
    base64.current = {};
    setVisiblePreview();
    marcas.current = { results: [] };
    setConfigsAsigPlacas([]);
    setMarcasTemp({ results: [] });
    setLineasTemp({ results: [] });
    setVersionFound();
    setSelectedKeys([]);
    setCargosGenerados([]);
    setCargosAdeudo([]);
    setEsPlacaDuplicada(false);
    setEsConsiderado(false);
    setFolioRepuve(null);
  };

  const resetAndValidatePropietario = () => {
    setPropietario();
    form.resetFields(['q_propietario', 'object_id_propietario']);
    form.validateFields(['q_propietario', 'object_id_propietario']);
  };

  const resetAndValidatePropietarioNuevo = () => {
    setPropietarioNuevo();
    form.resetFields(['q_propietario_nuevo', 'object_id_propietario_nuevo']);
    form.validateFields(['q_propietario_nuevo', 'object_id_propietario_nuevo']);
  };

  const FormItemSearchPropietario = ({
    name,
    label,
    disabled,
    inputProps,
    prefixProps,
    onClickAdvanced,
    resultProps,
  }) => (
    <InputSearchPro
      label={label}
      name={name}
      onClickAdvanced={onClickAdvanced}
      breakPoints={{
        md: 24,
      }}
      prefix={{
        rules: rules.required,
        label: 'Padrón',
        style: { width: 150 },
        allowClear: false,
        ...prefixProps,
      }}
      inputProps={inputProps}
      resultProps={{
        keyLabelRender: false,
        breakPoints: {
          md: 24,
        },
        ...resultProps,
      }}
      disabled={disabled}
    />
  );

  const isDeOtroEstado = (tipoDeTramite?.id === 5
    || tipoDeTramite?.id === 14 || tipoDeTramite?.id === 23);

  const isCambioServicio = tipoDeTramite?.id === 47;

  const resetAndValidateTramite = () => {
    setTramite();
    form.resetFields(['folio', 'id_tramite']);
    form.validateFields(['folio', 'id_tramite']);
  };

  const resetAndValidateOrdenDePago = () => {
    setOrdenPagada();
    form.resetFields(['folio_referencia', 'id_orden']);
    form.validateFields(['folio_referencia', 'id_orden']);
  };

  const retrieversPadronesMap = {
    1: getCiudadano,
    4: getVehiculo,
    15: getContribuyente,
    16: getMotocicleta,
    17: getRemolque,
  };

  const getPropietario = async (tipoDePadron, id) => {
    const _propietario = await retrieversPadronesMap[tipoDePadron](id);
    return _propietario;
  };

  const getPadronVehicular = async (tipoDePadron, id) => {
    const _vehiculo = await retrieversPadronesMap[tipoDePadron](id);
    return _vehiculo;
  };

  const getMarcasMap = {
    4: getMarcasDeVehiculos,
    16: getMarcasDeMotocicletas,
    17: getMarcasDeRemolques,
  };

  const fetchVersion = async (record) => {
    setLoading(true);
    if (record?.id) {
      const _version = await getVersionVehicular(record?.id);
      if (_version) {
        const match = {
          ..._version,
          descripcion_completa: `${_version?.tipo_de_vehiculo_en_version} -
          ${_version?.marca_en_version} -
          ${_version?.linea_en_version} - 
          ${_version?.descripcion}`.replace(' - undefined', ''),
        };
        form.setFieldsValue({
          version_vehicular: _version.id,
        });
        setVersionFound([match]);
      } else {
        setVersionFound([]);
      }
    }
    setLoading(false);
  };

  const getVehiculoFks = async (_vehiculo, _tipoDePadronVehicular) => {
    if (_vehiculo.linea && typeof _vehiculo.linea === 'number') {
      const _lineasTemp = await getLineasVehiculares({ id: _vehiculo.linea });
      setLineasTemp(_lineasTemp);
      const [_linea] = _lineasTemp.results;
      if (_linea?.marca) {
        // eslint-disable-next-line no-param-reassign
        _vehiculo.marca = _linea.marca;
        const _marcasTemp = await getMarcasMap[_tipoDePadronVehicular]({ id: _linea.marca });
        setMarcasTemp(_marcasTemp?.results ? _marcasTemp : { results: _marcasTemp });
      }
    } else if (_vehiculo?.marca) {
      const _marcasTemp = await getMarcasMap[_tipoDePadronVehicular]({ id: _vehiculo.marca });
      setMarcasTemp(_marcasTemp?.results ? _marcasTemp : { results: _marcasTemp });
    }
    if (_vehiculo.version_vehicular) {
      await fetchVersion({ id: _vehiculo.version_vehicular });
    }
  };

  const fkByTipoDePadron = {
    4: 'vehiculo',
    16: 'motocicleta',
    17: 'remolque',
  };

  const patchVehicularMap = {
    4: patchVehiculo,
    16: patchMotocicleta,
    17: patchRemolque,
  };
  const mapClasesMotoRemolque = {
    16: 17,
    17: 18,
  };
  const getPlacasSiguientes = async () => {
    setLoading(true);
    const _configsAsigPlacas = await postGetConfiguracionDeAsignacionDePlacas({
      servicio: vehiculo?.servicio,
      clase_del_vehiculo: tipoDePadronVehicular === 4 ? vehiculo?.clase_del_vehiculo
        : mapClasesMotoRemolque[tipoDePadronVehicular],
    });
    if (_configsAsigPlacas.length) {
      const [_confAsigPlacas] = _configsAsigPlacas;
      if (tipoDePadronVehicular !== 17) {
        form.setFieldsValue({
          confAsigPlaca: _confAsigPlacas.id,
          numero_de_placa_vigente: _confAsigPlacas.numero_de_placa_siguiente,
        });
      } else {
        form.setFieldsValue({
          confAsigPlaca: _confAsigPlacas.id,
          placa: _confAsigPlacas.numero_de_placa_siguiente,
        });
      }
    } else if (!_configsAsigPlacas.length) {
      message.info('No se encontraron asignaciones de placas para el usuario actual');
    }
    setConfigsAsigPlacas(_configsAsigPlacas);
    setLoading(false);
  };

  const searchTramite = async (_folio) => {
    setLoading(true);
    const folio = _folio || form.getFieldValue('folio');
    if (folio) {
      const matches = await getTramites({ folio });
      const [_tramite] = matches;
      if (_tramite) {
        _tramite.solicitante_ciudadano = !_tramite.contribuyente;
        const _tipoDePadronSolicitante = _tramite.solicitante_ciudadano ? 1 : 15;
        const _tipoDePadronVehicular = getTipoDePadronPorContenType(
          _tramite.content_type_a_padron,
        );
        const idSolicitante = _tramite.solicitante_ciudadano
          ? _tramite.ciudadano : _tramite.contribuyente;
        await checkToken();
        const [_solicitante, _vehiculo] = await Promise.all([
          await getPropietario(
            _tipoDePadronSolicitante,
            idSolicitante,
          ),
          await getPadronVehicular(
            _tipoDePadronVehicular,
            _tramite.object_id_padron,
          ),
        ]);
        const idPropietario = _vehiculo.es_propietario_ciudadano
          ? _vehiculo.propietario
          || _vehiculo.ciudadano_propietario
          || _vehiculo.ciudadano_propietario?.id
          : _vehiculo.contribuyente_propietario;
        const _tipoDePadronPropietario = _vehiculo.es_propietario_ciudadano ? 1 : 15;
        const _propietario = await getPropietario(
          _tipoDePadronPropietario,
          idPropietario,
        );

        const _tramiteFinalizado = _tramite.estados_globales === 4;
        const _tipoDeTramite = tiposDeTramites
          .find((e) => e.plantilla_de_tramites?.id === _tramite.plantilla);

        if (_tipoDeTramite?.id === 47) {
          _vehiculo.hasNumeroEconomico = true;
        }
        if (_vehiculo && MAP_IDS_POR_TIPO_DE_TRAMITE.ALTA.includes(_tipoDeTramite?.id)) {
          _vehiculo.canContinue = true;
        }
        if (_vehiculo && MAP_IDS_POR_TIPO_DE_TRAMITE.CAMBIO.includes(_tipoDeTramite?.id)) {
          _vehiculo.hasRFC = true;
        }
        if (MAP_IDS_POR_TIPO_DE_TRAMITE.CAMBIO.includes(_tipoDeTramite.id)) {
          setTimeout(() => {
            setTipoDePadronPropietarioNuevo(_tipoDePadronSolicitante);
            setPropietarioNuevo(_solicitante);
          });
        }
        const cargos = await getCargos({
          tramite: _tramite.id,
          eliminado: false,
          cancelado: false,
        });
        _tramite.cargos = cargos;
        _tramite.cargosSaldados = _tramiteFinalizado
          || (_tramite.cargos.length && _tramite.cargos.every((e) => e.saldado));
        const _isRefrendoReemplacamiento = /^(SAF-DRI-03)(6|7)$/.test(_tipoDeTramite.plantilla_de_tramites?.homoclave);
        const _isRefrendoDePortal = /^(SAF-DRI-038)$/.test(_tipoDeTramite.plantilla_de_tramites?.homoclave);
        const _isReemplacamientoDePortal = /^(SAF-DRI-039)$/.test(_tipoDeTramite.plantilla_de_tramites?.homoclave);
        const folioRecibo = _tramite.cargosSaldados
          // eslint-disable-next-line no-use-before-define
          ? await getRecibo(_tramite.cargos[0].id, false) : null;
        _tramite.folios = folioRecibo;
        base64.current[VISIBLE_PREVIEW_ENUM.RECIBO] = null;
        const inProcess = _tramite?.estados_globales === 2;
        const _isDeOtroEstado = (_tipoDeTramite?.id === 5
          || _tipoDeTramite?.id === 14 || _tipoDeTramite?.id === 23);
        if (MAP_IDS_POR_TIPO_DE_TRAMITE.BAJA.includes(_tipoDeTramite.id)
          || _isRefrendoReemplacamiento || _isReemplacamientoDePortal) {
          if (_tramite.cargosSaldados) {
            if ((folioRecibo && _tramiteFinalizado) || (folioRecibo && inProcess)) {
              const params = { folio_de_recibo: _tramite.folios };
              let [placa] = await getPlacas(params);
              if (!placa) {
                params[fkByTipoDePadron[_tipoDePadronVehicular]] = _vehiculo.id;
                if (_vehiculo.contribuyente_propietario) {
                  params.contribuyente_propietario = _vehiculo.contribuyente_propietario?.id
                    || _vehiculo.contribuyente_propietario;
                } else {
                  const ciudadano = _vehiculo.propietario || _vehiculo.ciudadano_propietario;
                  params.ciudadano = ciudadano?.id || ciudadano;
                }
                if (inProcess && !placa) {
                  delete params.folio_de_recibo;
                }
                [placa] = await getPlacas(params);
              }

              if (placa && _tramite.folios) {
                _tramite.placa = {
                  numero_de_placa: placa.numero_de_placa,
                  cantidad_de_placas: placa.cantidad_de_placas,
                  folio_de_recibo: placa.folio_de_recibo,
                  estado: !_isDeOtroEstado ? placa.estado : null,
                  folio_de_documento_de_denuncia: placa.folio_de_documento_de_denuncia,
                };
                if (tipoDePadronVehicular !== 17 && !_vehiculo?.numero_de_placa_vigente
                  && placa
                  && inProcess && (!_isRefrendoReemplacamiento && !_isReemplacamientoDePortal)) {
                  const values = {
                    ..._vehiculo,
                    numero_de_placa_vigente: placa?.numero_de_placa,
                  };
                  const patched = await patchVehicularMap[tipoDePadronVehicular](
                    _vehiculo.id,
                    values,
                  );
                  if (patched) {
                    _vehiculo.numero_de_placa_vigente = placa.numero_de_placa;
                  }
                } else if (tipoDePadronVehicular === 17 && !_vehiculo?.placa
                  && placa
                   && inProcess && (!_isRefrendoReemplacamiento && !_isReemplacamientoDePortal)) {
                  const values = {
                    ..._vehiculo,
                    numero_de_placa_vigente: placa?.numero_de_placa,
                  };
                  const patched = await patchVehicularMap[tipoDePadronVehicular](_vehiculo.id,
                    values);
                  if (patched) {
                    _vehiculo.numero_de_placa = placa.numero_de_placa;
                  }
                }
                _vehiculo.hasPlacaObject = true;
              }
            }
            if (!inProcess) {
              setCurrentStep(tipoDePadronPropietario === 1 ? 3 : 2);
            }
          } else if (
            ((!_isRefrendoReemplacamiento || !_isReemplacamientoDePortal)
            && !_isDeOtroEstado
            && !_tramite.cargosSaldados)) {
            message.info('Los cargos pendientes de este trámite no han sido saldados');
          }
        }
        if (_solicitante && _vehiculo) {
          const noAplica = await getMessageConsiderado(_solicitante.id);
          if (noAplica.detail) {
            form.setFieldsValue({
              es_ciudadano_considerado: false,
            });
            setEsConsiderado(false);
            _vehiculo.hasDiscount = true;
          }
        }

        if (_solicitante && _vehiculo) {
          await getVehiculoFks(_vehiculo, _tipoDePadronVehicular);
          setTramite(_tramite);
          setVehiculo(_vehiculo);
          setTipoDePadronPropietario(_tipoDePadronPropietario);
          setPropietario(_propietario);
          setTipoDePadronVehicular(_tipoDePadronVehicular);
          setTipoDeTramite(_tipoDeTramite);
          if (_folio) {
            form.setFieldsValue(_tramite);
          } else {
            form.setFieldsValue({
              object_id_propietario_nuevo: _solicitante.id,
              object_id_propietario: _propietario.id,
              object_id_vehiculo: _vehiculo.id,
            });
          }
          if (_vehiculo) {
            form.setFieldsValue(_vehiculo);
          }
        }
        if (_isDeOtroEstado && _tramite.cargosSaldados) {
          setCurrentStep(tipoDePadronPropietario === 1 ? 3 : 2);
        }
        if (_isDeOtroEstado && _tramite.cargosSaldados) {
          setCurrentStep(tipoDePadronPropietario === 1 ? 3 : 2);
        }
        if (_isRefrendoReemplacamiento && _tramite.cargosSaldados && !inProcess) {
          setCurrentStep(tipoDePadronPropietario === 1 ? 5 : 4);
        }
        if (_isRefrendoDePortal && !inProcess) {
          setCurrentStep(2);
        }
        if (_isReemplacamientoDePortal && !inProcess) {
          setCurrentStep(4);
        }
      } else {
        message.info('No se encontró trámite con el folio brindado');
      }
    }
    setLoading(false);
  };

  const FormItemSearchTramite = () => (
    <InputSearchPro
      label="Búsqueda por Folio"
      name="folio"
      breakPoints={{
        md: 24,
      }}
      inputProps={{
        onPressEnter: () => searchTramite(),
        onChange: ({ target: { value } }) => {
          if (!value) {
            resetAndValidateTramite();
          }
        },
      }}
      resultProps={{
        keyLabelRender: false,
        breakPoints: {
          md: 24,
        },
        name: 'tramite',
        label: 'Trámite',
        rules: rules.required,
        dataSource: tramite,
        render: (item) => item.folio,
        onClear: () => resetAndValidateTramite(),
      }}
    />
  );

  const padronAccent = padronesVehiculares
    .find((e) => e.id === tipoDePadronVehicular)?.descripcion.replace('Vehiculo', 'Vehículo');

  const resetAndValidateVehiculo = () => {
    setVehiculo();
    setMarcasTemp({ results: [] });
    setLineasTemp({ results: [] });
    setVersionFound();
    form.resetFields(['q_vehiculo', 'object_id_vehiculo', 'q_version']);
    form.validateFields(['q_vehiculo', 'object_id_vehiculo']);
    form.validateFields(['q_vehiculo', 'object_id_vehiculo']);
  };

  const FormItemSearchVehiculo = ({
    disabled,
    callback,
    searchPadron: _searchPadron,
    disabledTipo,
    allowClear,
  }) => (
    <InputSearchPro
      label={padronAccent}
      name="q_vehiculo"
      onClickAdvanced={() => setVisibleBusquedaVehiculo(true)}
      breakPoints={{
        md: 24,
      }}
      prefix={{
        rules: rules.required,
        dataSource: padronesVehiculares,
        label: 'Padrón',
        name: 'tipo_de_padron_vehicular',
        onChange: setTipoDePadronVehicular,
        style: { width: 150 },
        allowClear: false,
        disabled: disabledTipo,
      }}
      inputProps={{
        onPressEnter: () => (_searchPadron ? _searchPadron()
          : searchPadron(setVehiculo, 'object_id_vehiculo', 'q_vehiculo', tipoDePadronVehicular, callback)),
        onChange: ({ target: { value } }) => {
          if (!value) {
            resetAndValidateVehiculo();
          }
        },
      }}
      resultProps={{
        name: 'object_id_vehiculo',
        label: padronesVehiculares.find((e) => e.id === tipoDePadronVehicular)?.descripcion,
        dataSource: vehiculo,
        render: (padron) => padronToString(padron, tipoDePadronVehicular),
        onClear: allowClear ? () => resetAndValidateVehiculo() : null,
        breakPoints: {
          md: 24,
        },
      }}
      disabled={disabled}
    />
  );

  const SearchPropietario = ({ allowClear = true }) => (
    <FormItemSearchPropietario
      title="Búsqueda/Registro del propietario"
      name="q_propietario"
      label={padronesPropietarios
        .find((e) => e.id === tipoDePadronPropietario)?.descripcion}
      onClickAdvanced={() => setVisibleBusquedaPropietario(true)}
      prefixProps={{
        dataSource: padronesPropietarios,
        name: 'tipo_de_padron_propietario',
        onChange: setTipoDePadronPropietario,
      }}
      inputProps={{
        onPressEnter: () => searchPadron(setPropietario, 'object_id_propietario', 'q_propietario', tipoDePadronPropietario),
        onChange: ({ target: { value } }) => {
          if (!value) {
            resetAndValidatePropietario();
          }
        },
      }}
      resultProps={{
        name: 'object_id_propietario',
        label: padronesPropietarios
          .find((e) => e.id === tipoDePadronPropietario)?.descripcion,
        dataSource: propietario,
        render: (padron) => padronToString(padron, tipoDePadronPropietario),
        rules: rules.required,
        onClear: allowClear ? () => resetAndValidatePropietario() : null,
      }}
      disabled={!!(vehiculo || tramite)}
    />
  );

  const SearchNuevoPropietario = () => (
    <FormItemSearchPropietario
      title="Búsqueda"
      name="q_propietario_nuevo"
      label={padronesPropietarios
        .find((e) => e.id === tipoDePadronPropietarioNuevo)?.descripcion}
      onClickAdvanced={() => setVisibleBusquedaPropietarioNuevo(true)}
      prefixProps={{
        dataSource: padronesPropietarios,
        name: 'tipo_de_padron_propietario_nuevo',
        onChange: setTipoDePadronPropietarioNuevo,
      }}
      inputProps={{
        onPressEnter: () => searchPadron(
          setPropietarioNuevo,
          'object_id_propietario_nuevo',
          'q_propietario_nuevo',
          tipoDePadronPropietarioNuevo,
        ),
        onChange: ({ target: { value } }) => {
          if (!value) {
            resetAndValidatePropietarioNuevo();
          }
        },
      }}
      resultProps={{
        name: 'object_id_propietario_nuevo',
        label: padronesPropietarios
          .find((e) => e.id === tipoDePadronPropietarioNuevo)?.descripcion,
        dataSource: propietarioNuevo,
        render: (padron) => padronToString(padron, tipoDePadronPropietarioNuevo),
        rules: rules.required,
        onClear: () => resetAndValidatePropietarioNuevo(),
      }}
      disabled={vehiculo}
    />
  );

  const onFoundVehiculo = async (
    _vehiculo,
    _setTipoDePadronPropietario = setTipoDePadronPropietario,
    _setPropietario = setPropietario,
  ) => {
    const object_id_propietario = _vehiculo.es_propietario_ciudadano
      ? _vehiculo.propietario?.id || _vehiculo.propietario || _vehiculo.ciudadano_propietario
      : _vehiculo.contribuyente_propietario?.id || _vehiculo.contribuyente_propietario;
    if (object_id_propietario) {
      const tipo_de_padron_propietario = _vehiculo.es_propietario_ciudadano ? 1 : 15;
      const _propietario = await retrieversPadronesMap[tipo_de_padron_propietario](
        object_id_propietario?.id || object_id_propietario,
      );
      if (_propietario) {
        const isObject = typeof object_id_propietario === 'object';
        _setPropietario(_propietario);
        _setTipoDePadronPropietario(tipo_de_padron_propietario);
        form.setFieldsValue({
          object_id_propietario: isObject ? object_id_propietario?.id : object_id_propietario,
          tipo_de_padron_propietario,
        });
      }
    }
  };

  const SearchVehiculo = ({
    disabled,
    callback,
    searchPadron: _searchPadron,
    allowClear,
  }) => (
    <FormItemSearchVehiculo
      callback={callback}
      disabled={disabled}
      label={`Búsqueda del ${padronVehicularLabel}`}
      searchPadron={_searchPadron}
      allowClear={allowClear}
      disabledTipo
    />
  );

  const SaveButton = ({
    title,
    icon,
    danger,
    disabled,
  }) => (
    <Col span={8}>
      <Form.Item style={{ marginTop: 22 }}>
        <Button block htmlType="submit" danger={danger} disabled={disabled}>
          {title || 'Guardar'}
          {icon || <SaveOutlined />}
        </Button>
      </Form.Item>
    </Col>
  );

  const validateObjetoPlaca = async (_vehiculo = vehiculo) => {
    const numeroDePlaca = _vehiculo[tipoDePadronVehicular === 17 ? 'placa' : 'numero_de_placa_vigente'];
    const params = {};
    params.vigente = _vehiculo.estatus_del_vehiculo === 1;
    if (numeroDePlaca && params.vigente) {
      params.numero_de_placa = numeroDePlaca;
    } else {
      params[fkByTipoDePadron[tipoDePadronVehicular]] = _vehiculo.id;
      if (_vehiculo.contribuyente_propietario) {
        params.contribuyente_propietario = _vehiculo.contribuyente_propietario?.id
          || _vehiculo.contribuyente_propietario;
      } else {
        const ciudadano = _vehiculo.propietario || _vehiculo.ciudadano_propietario;
        params.ciudadano = ciudadano?.id || ciudadano;
      }
    }
    const [placa] = await getPlacas(params);
    // si existe placa y vehiculo no tiene placa se hizo post de placa pero fallo patch de vehiculo
    // si vehiculo tiene placa pero placa no existe no se ha hecho el post de placa
    if ((numeroDePlaca && !placa) || (placa && !numeroDePlaca)) {
      const values = { numero_de_placa: numeroDePlaca, vigente: true };
      const hasPlacaObject = await saveOrLinkPlaca(
        values,
        tipoDePadronVehicular,
        _vehiculo,
        setLoading,
        null,
        placa,
      );
      setVehiculo({
        ..._vehiculo,
        hasPlacaObject,
        [tipoDePadronVehicular === 17
          ? 'placa' : 'numero_de_placa_vigente']: placa?.numero_de_placa || numeroDePlaca,
      });
      return hasPlacaObject;
    } if (!numeroDePlaca && !placa) {
      setVehiculo({
        ..._vehiculo,
      });
      setVisiblePlaca(true);
      return false;
    }
    setVehiculo({
      ..._vehiculo,
      hasPlacaObject: true,
    });
    return true;
  };
  const msgInfoBaja = 'El padron que se está buscando no se encuentra en en estado de Baja';
  const msgInfoAlta = 'El padron que se está buscando no se encuentra en en estado de Alta';

  const searchVehiculoEnBaja = async (id) => {
    setLoading(true);
    const q = form.getFieldValue('q_vehiculo');
    if (q || id) {
      const keyPropietario = (tipoDePadronPropietario === 15 && 'contribuyente_propietario')
        || (tipoDePadronVehicular === 17 ? 'ciudadano_propietario' : 'propietario');
      const params = {
        estatus_del_vehiculo: isCambio || isAlta ? 2 : 1,
        [id ? 'id' : 'q']: id || q,
      };
      if (!isAlta || isDeOtroEstado) {
        params[keyPropietario] = propietario?.id;
      }
      const _matches = await gettersPadronesMap[tipoDePadronVehicular](params, false);
      const matches = (_matches.results || _matches)
        .filter((e) => e.estatus_del_vehiculo === params.estatus_del_vehiculo
          && (!params[keyPropietario] || params[keyPropietario] === propietario.id));
      if (matches.length === 1) {
        const [_vehiculo] = matches;
        await validateTramiteEnProceso(_vehiculo, tipoDePadronVehicular, async () => {
          await getVehiculoFks(_vehiculo, tipoDePadronVehicular);
          if (!propietario) {
            await onFoundVehiculo(_vehiculo);
          }

          if (isAlta
            && ((_vehiculo[keyPropietario]?.id || _vehiculo[keyPropietario]) === propietario?.id)) {
            _vehiculo.canContinue = true;
          }
          if (isBaja || isRefrendo) {
            setTimeout(() => validateObjetoPlaca(formatReceived(_vehiculo)));
          } else {
            setVehiculo(formatReceived(_vehiculo));
          }
          form.setFieldsValue({ ...formatReceived(_vehiculo), object_id_vehiculo: _vehiculo.id });
        });
      } else if (matches.length) {
        message.info('Ingrese una búsqueda más específica');
      } else {
        message.info(isDeOtroEstado ? msgInfoAlta : msgInfoBaja);
      }
    }
    setLoading(false);
  };

  const SearchVehiculoEnBaja = ({ visible, allowClear = true }) => visible && (
    <>
      <Col span={24}>
        <Typography.Title level={3}>
          {`Búsqueda ${padronVehicularLabel}`}
        </Typography.Title>
      </Col>
      <Col span={24}>
        <SearchVehiculo
          disabled={!!tramite}
          searchPadron={searchVehiculoEnBaja}
          allowClear={allowClear}
        />
      </Col>
    </>
  );

  const resetAndValidateVersion = () => {
    setVersionFound([]);
    form.resetFields(['q_version']);
  };

  const maxRule = (max, validateLength = true) => ({
    validator: async (rule, value) => {
      if (value) {
        if (validateLength) {
          if (value.length > max) {
            throw new Error(`Este campo no puede contener más de ${max} caracteres`);
          }
        } else if (value > max) {
          throw new Error(`Este campo no puede ser mayor a ${max}`);
        }
      }
    },
  });

  const searchVersion = async () => {
    setLoading(true);
    const { q } = form.getFieldsValue(['q_version']);
    if (q) {
      const _version = await getVersionesVehiculares({ descripcion: q });
      if ([1].includes(_version.results.length)) {
        const [selected] = _version.results.map((e) => ({
          ...e,
          descripcion_completa: `${e?.tipo_de_vehiculo_en_version} -
            ${e?.marca_en_version} -
             ${e?.linea_en_version} -
             ${e?.descripcion}`.replace(' - undefined', ''),
        }));
        form.setFieldsValue({
          version_vehicular: selected.id,
        });
        setVersionFound([selected]);
      } else if (_version.results.length > 1) {
        setDataExternoVersiones(_version);
        setVisibleBusquedaVersiones(true);
      } if (!_version.results.length) {
        message.info('No se encontró Versión Vehícular');
      }
    }
    setLoading(false);
  };

  const getMandatoryTypes = () => tipoDeTramite.tiposDeCargos.map(mapId);

  const getMandatoryKeys = (_cargosAdeudo) => {
    const mandatoryTypes = getMandatoryTypes();
    const matches = _cargosAdeudo
      .filter((c) => !c.es_accesorio && mandatoryTypes.includes(c.tipo_de_cargo?.id))
      .map(mapId);
    const accesories = matches
      .map((m) => _cargosAdeudo.filter((c) => c.es_accesorio && c.cargo_padre === m).map(mapId))
      .flat();
    return [...matches, ...accesories];
  };

  const onChangeSelectedKeysAdeudo = (_selectedKeys = [], _cargosAdeudo = cargosAdeudo) => {
    const mandatoryKeys = getMandatoryKeys(_cargosAdeudo);
    const notDisabledKeys = _selectedKeys
      .filter((k) => !_cargosAdeudo.find((c) => c.id === k).disabled);
    setSelectedKeys(getDistinctValues([...notDisabledKeys, ...mandatoryKeys]));
  };

  const isDisabledCargo = (cargo, _cargos) => {
    const mandatoryTypes = getMandatoryTypes();
    if (cargo.es_accesorio) {
      const cargoPadre = _cargos.find((c) => c.id === cargo.cargo_padre);
      return mandatoryTypes.includes(cargoPadre.tipo_de_cargo.id)
        || listDisabledChargesRefrendoBaja.includes(cargoPadre.tipo_de_cargo.id);
    }
    return mandatoryTypes.includes(cargo.tipo_de_cargo.id)
      || listDisabledChargesRefrendoBaja.includes(cargo.tipo_de_cargo.id);
  };

  const getAdeudo = async (padronID, attempt) => {
    setLoadingAdeudo(true);
    const response = await postConsultarCargosPorPadron(tipoDePadronVehicular, padronID, attempt);
    if (response.detail || response.status) {
      setMessageAdeudo(titleize(response.detail || response.status));
      setTimeout(
        () => getAdeudo(padronID, attempt + 1),
        (attempt === 0 ? 10 : 5) * 1000,
      );
    } else if (response.cargos) {
      const cargos = response.cargos.filter((c) => !c.tramite);
      const normalized = normalizeCargos(cargos.map((cargo) => ({
        ...cargo,
        disabled: isDisabledCargo(cargo, cargos),
      })));
      setCargosAdeudo(normalized);
      setTimeout(() => onChangeSelectedKeysAdeudo([], normalized));
      setLoadingAdeudo(false);
    } else {
      setMessageAdeudo(errorMessage);
      setLoadingAdeudo(false);
    }
  };

  const isVehiculoEnRefrendo = !tramite && isRefrendo && isVehiculo && !isServicioPublico;
  const isMotoEnRefrendo = !tramite && isRefrendo && isMoto && !isServicioPublico;

  const searchVehiculoEnAlta = async (id) => {
    setLoading(true);
    const q = form.getFieldValue('q_vehiculo');
    if (q || id) {
      const params = {};
      if (id) {
        params.id = id;
      } else {
        params.q = q;
      }
      if (!isRefrendo) {
        params.estados_globales = 1;
        params.estatus_del_vehiculo = 1;
      }
      const _matches = await gettersPadronesMap[tipoDePadronVehicular](params, false);
      const matches = (_matches.results || _matches)
        .filter((e) => isRefrendo || (e.estados_globales === 1 && e.estatus_del_vehiculo === 1));
      if (matches.length === 1) {
        const [_padronFound] = matches;
        if ((isVehiculoEnRefrendo || isMotoEnRefrendo) && !tramitePortalReemplacamiento) {
          await getAdeudo(_padronFound.id);
        }
        await getVehiculoFks(_padronFound, tipoDePadronVehicular);
        await onFoundVehiculo(_padronFound);
        if (isBaja || isRefrendo) {
          setTimeout(() => validateObjetoPlaca(_padronFound));
        } else {
          setVehiculo(_padronFound);
        }
        form.setFieldsValue({
          ...formatReceived(_padronFound),
          object_id_vehiculo: _padronFound.id,
        });
      } else if (matches.length) {
        message.info('Ingrese una búsqueda más específica');
      } else {
        message.info(msgInfoAlta);
      }
    }
    setLoading(false);
  };

  const searchReferenciaAndVehicle = async () => {
    setLoading(true);
    const { metodo_busqueda: selectedMethod, folio_referencia: folio } = form.getFieldsValue();
    if (selectedMethod === 1) {
      const _referencia = await getOrdenDePago({ folio, estado_del_folio: 2 });
      if (_referencia) {
        const tipoDePadronRef = _referencia?.tipo_de_padron;
        const [_referenciaUsada] = await getTramites({
          content_type_a_padron: getContenTypePorTipoDePadron(tipoDePadronVehicular),
          object_id_padron: _referencia?.padron_id,
          estados_globales: 4,
          plantilla: tipoDeTramite.plantilla_de_tramites.id,
        });
        if (!_referenciaUsada && (tipoDePadronRef === tipoDePadronVehicular)) {
          setOrdenPagada(_referencia);
          if (!tramitePortalReemplacamiento) {
            await searchVehiculoEnBaja(_referencia?.padron_id);
          } else {
            await searchVehiculoEnAlta(_referencia?.padron_id);
          }
        } else if (tipoDePadronRef !== tipoDePadronVehicular) {
          message.info('La referencia que estas buscando no pertenece al tipo de padron en el que te encuentras');
        } else {
          message.info(`La referencia que estas buscando ya se uso para un trámite previamente (${_referenciaUsada.folio})`);
        }
      } else {
        message.info('No se encontró la referencia que estás buscando o no esta saldada');
      }
    } else {
      const _recibo = await getRecibos({ folio });
      if (_recibo?.results) {
        const contentTypeRecibo = _recibo?.results[0]?.content_type_padron;
        const [_reciboUsado] = await getTramites({
          content_type_a_padron: getContenTypePorTipoDePadron(tipoDePadronVehicular),
          object_id_padron: _recibo?.results[0]?.object_id_padron,
          estados_globales: 4,
          plantilla: tipoDeTramite.plantilla_de_tramites.id,
        });
        if (!_reciboUsado
          && contentTypeRecibo === getContenTypePorTipoDePadron(tipoDePadronVehicular)) {
          _recibo.results[0].cargos = _recibo?.results[0]?.abonos.map((abono) => abono.cargo);
          setOrdenPagada(_recibo.results[0]);
          if (!tramitePortalReemplacamiento) {
            await searchVehiculoEnBaja(_recibo?.results[0]?.object_id_padron);
          } else {
            await searchVehiculoEnAlta(_recibo?.results[0]?.object_id_padron);
          }
        } else if (contentTypeRecibo !== getContenTypePorTipoDePadron(tipoDePadronVehicular)) {
          message.info('El recibo que estas buscando no pertenece al tipo de padron en el que te encuentras');
        } else {
          message.info(`El recibo que estas buscando ya se uso para un trámite previamente (${_reciboUsado?.folio})`);
        }
      } else {
        message.info('No se encontró el recibo que estas buscando');
      }
    }
    setLoading(false);
  };
  const FormItemSearchOrden = () => (
    <InputSearchPro
      label="Búsqueda por Folio"
      name="folio_referencia"
      breakPoints={{
        md: 24,
      }}
      prefix={{
        dataSource: searchMethods,
        label: 'Método',
        name: 'metodo_busqueda',
        style: { width: 100 },
        allowClear: false,
      }}
      inputProps={{
        onPressEnter: () => searchReferenciaAndVehicle(),
        onChange: ({ target: { value } }) => {
          if (!value) {
            resetAndValidateOrdenDePago();
          }
        },
      }}
      resultProps={{
        keyLabelRender: false,
        breakPoints: {
          md: 24,
        },
        name: 'folio_referencia',
        label: 'Folio de Orden',
        rules: rules.required,
        dataSource: ordenPagada,
        render: (item) => item.folio,
        onClear: () => resetAndValidateOrdenDePago(),
      }}
    />
  );

  const AddPlacaButton = () => (vehiculo?.hasPlacaObject ? null : (
    <Col xs={24} sm={24} md={8}>
      <Button
        block
        onClick={() => (vehiculo?.hasPlacaObject ? validateObjetoPlaca() : setVisiblePlaca(true))}
        style={{ marginTop: 21 }}
        disabled={!vehiculo}
      >
        Agregar Placa
      </Button>
    </Col>
  ));

  const AddVehiculo = ({ disabled }) => (
    <>
      <SearchVehiculoEnBaja visible={!vehiculo} />
      {((isAlta || vehiculo || (!vehiculo && isDeOtroEstado))) && (
        <>
          <Col span={24}>
            <Typography.Title level={3}>
              {`Alta ${padronVehicularLabel}`}
            </Typography.Title>
          </Col>
          <Col span={8}>
            <Form.Item
              label="Propietario"
              name="object_id_propietario"
              rules={rules.required}
            >
              <Select
                render={(e) => padronToString(e, tipoDePadronPropietario)}
                dataSource={[propietario]}
                allowClear={false}
                showArrow={false}
                disabled
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              label="Serie"
              name="numero_de_identificacion_vehicular"
              normalize={toUpper}
              tooltip="Número de Identificación Vehícular"
              rules={[...rules.required, maxRule(17)]}
              maxLength={17}

            >
              <Input allowClear disabled={disabled} maxLength={17} />
            </Form.Item>
          </Col>
          {isDeOtroEstado ? (
            <>
              <AddPlacaButton />
              <Col span={8}>
                <Form.Item
                  name="numero_de_placa_vigente"
                  label="Número de Placa"
                  rules={(isDeOtroEstado && vehiculo) ? rules.required : null}
                  normalize={noSymbolsCapitalized}
                >
                  <Input disabled />
                </Form.Item>
              </Col>
            </>
          ) : (
            <>
              <Col span={8}>
                <Form.Item
                  name="numero_de_placa_vigente"
                  label="Número de Placa"
                  normalize={noSymbolsCapitalized}
                >
                  <Input disabled placeholder="Por asignar" />
                </Form.Item>
              </Col>
            </>
          )}
          <Col span={8}>
            <Form.Item
              name="numero_de_motor"
              label="Número de Motor"
              normalize={capitalize}
              rules={[...rules.required, maxRule(50)]}
            >
              <Input allowClear disabled={disabled} maxLength={50} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="numero_de_chasis"
              label="Número de Chasis"
              normalize={capitalize}
              rules={[maxRule(50)]}
            >
              <Input allowClear disabled={disabled} maxLength={50} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="clave_de_la_secretaria_de_hacienda_y_credito_publico"
              label="Clave Nacional"
              tooltip="Clave de la Secretaria de Hacienda y Crédito Público"
              normalize={capitalize}
              rules={[maxRule(40)]}
            >
              <Input allowClear disabled={disabled} maxLength={40} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="unidad_de_recaudacion"
              label="Unidad de Recaudación"
              rules={rules.required}
            >
              <Select dataSource={unidadesDeRecaudacion} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="numero_de_pedimento"
              label="Número de pedimento"
              rules={[...rules.slug, maxRule(50)]}
              tooltip="Letras, números, guiones y guiones bajos"
            >
              <Input allowClear disabled={disabled} maxLength={50} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <NumericInput
              name="modelo"
              label="Modelo"
              tooltip="Año del vehículo"
              required
              maxLength={4}
              minLength={4}
              disabled={disabled}
            />
          </Col>
          <Col span={8}>
            <Form.Item
              name="marca"
              label="Marca"
              rules={rules.required}
            >
              <Select
                dataSource={marcasTemp.results.length ? marcasTemp : marcas.current}
                usingExternalDataSource={Boolean(marcasTemp.results.length)}
                labelProp="nombre"
                onChange={() => {
                  form.resetFields(['linea']);
                }}
                onClear={() => {
                  form.resetFields(['linea']);
                  if (marcasTemp.results.length) {
                    setMarcasTemp({ results: [] });
                  }
                }}
                disabled={disabled}
                pagination={{
                  getter: getMarcasDeVehiculos,
                  setter: (dataSource) => {
                    marcas.current = dataSource;
                  },
                  config: {
                    auto: true,
                    qName: 'nombre',
                    selfValue: marca,
                  },
                }}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="linea"
              label="Línea"
              rules={rules.required}
            >
              <Select
                dataSource={lineasTemp.results.length ? lineasTemp : lineas.current}
                usingExternalDataSource={Boolean(lineasTemp.results.length)}
                labelProp="nombre"
                disabled={!marca || disabled}
                onChange={() => {
                  form.resetFields(['version_vehicular']);
                }}
                onClear={() => form.resetFields(['version_vehicular'])}
                pagination={{
                  getter: getLineasVehiculares,
                  setter: (dataSource) => {
                    lineas.current = dataSource;
                  },
                  params: { marca },
                  config: { qName: 'nombre' },
                }}
              />
            </Form.Item>
          </Col>
          <InputSearchPro
            disabled={disabled}
            tooltip="Búsqueda por descripción"
            label="Versión Vehícular"
            name="q_version"
            onClickAdvanced={() => setVisibleBusquedaVersiones(true)}
            breakPoints={{
              xs: 24,
              sm: 24,
              md: 8,
            }}
            inputProps={{
              onPressEnter: () => searchVersion(),
              onChange: ({ target: { value } }) => {
                if (!value) {
                  resetAndValidateVersion();
                }
              },
            }}
            resultProps={{
              name: 'version_vehicular',
              label: 'Versión Vehícular',
              dataSource: versionFound,
              labelProp: 'descripcion_completa',
              onClear: resetAndValidateVersion,
              breakPoints: {
                xs: 24,
                sm: 24,
                md: 8,
              },
            }}
          />
          <Col span={8}>
            <Form.Item
              name="uso_del_vehiculo"
              label="Uso del Vehículo"
              rules={rules.required}
            >
              <Select
                dataSource={usos}
                disabled={disabled}
                keyLabelRender
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="tipo_de_vehiculo"
              label="Tipo de Vehículo"
              rules={rules.required}
            >
              <Select
                dataSource={tipoDeVehiculo}
                labelProp="nombre"
                disabled={disabled}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="clase_del_vehiculo"
              label="Clase del Vehículo"
              rules={rules.required}
            >
              <Select
                dataSource={claseDelVehiculo}
                labelProp="nombre"
                disabled={disabled}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="tipo_de_combustible"
              label="Tipo de Combustible"
              rules={rules.required}
            >
              <Select dataSource={tipoDeCombustible} disabled={disabled} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <NumericInput
              name="cilindraje"
              label="Cilindraje"
              required
              disabled={disabled}
            />
          </Col>
          <Col span={8}>
            <NumericInput
              name="numero_de_puertas"
              label="Número de puertas"
              required
              disabled={disabled}
            />
          </Col>
          <Col span={8}>
            <NumericInput
              name="peso_del_vehiculo"
              label="Peso del Vehículo"
              decimal
              disabled={disabled}
            />
          </Col>
          <Col span={8}>
            <Form.Item
              name="capacidad_de_pasajeros"
              label="Capacidad de Pasajeros"
              tooltip="Número de pasajeros para los que se diseñó el vehículo"
              rules={[...rules.required, maxRule(2147483647, false)]}
              normalize={(val) => toInteger(val)}
            >
              <Input disabled={disabled} maxLength={10} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <NumericInput
              name="capacidad_de_carga"
              label="Capacidad de Carga"
              tooltip="Capacidad de carga del vehículo"
              disabled={disabled}
              decimal
            />
          </Col>
          <Col span={8}>
            <Form.Item
              name="color_del_vehiculo"
              label="Color del Vehículo"
              rules={rules.required}
            >
              <Select dataSource={colores} disabled={disabled} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="color_secundario"
              label="Color Secundario"
              rules={[...rules.required, maxRule(30)]}
            >
              <Input allowClear disabled={disabled} maxLength={30} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="servicio"
              label="Servicio"
              rules={rules.required}
            >
              <Select dataSource={servicios} labelProp="nombre" disabled={disabled} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="clave_de_servicio_publico"
              label="Clave del Servicio Público"
              normalize={capitalize}
              tooltip="Letras, números, guiones y guiones bajos"
              rules={rules.slug}
            >
              <Input allowClear disabled={disabled} maxLength={10} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="numero_economico"
              label="Número Económico"
              rules={isServicioPublico ? rules.required : null}
            >
              <Input allowClear disabled={disabled} maxLength={50} />
            </Form.Item>
          </Col>
          {isServicioPublico && (
          <Col span={8}>
            <Form.Item
              name="numero_economico_anterior"
              label="Número Económico Anterior"
              rules={isServicioPublico ? rules.required : null}
            >
              <Input allowClear disabled={disabled} maxLength={50} />
            </Form.Item>
          </Col>
          )}
            {(isCambioServicio && !vehiculo?.hasNumeroEconomico) && (
            <>
              <Col xs={24} sm={24} md={8}>
                <Button
                  onClick={() => {
                    setVisibleWidget(true);
                  }}
                  block
                  style={{ marginTop: 21 }}

                >
                  Agregar Datos Requeridos
                </Button>
              </Col>
            </>
            )}
          <Col span={8}>
            <Form.Item
              name="tarjeta_de_circulacion"
              label="Tarjeta de Circulación"
              normalize={capitalize}
              rules={[maxRule(12)]}
            >
              <Input allowClear disabled={disabled} maxLength={12} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="numero_de_calcomania"
              label="Número de calcomanía"
              normalize={capitalize}
              rules={[...rules.slug, maxRule(50)]}
              tooltip="Letras, números, guiones y guiones bajos"
            >
              <Input allowClear disabled={disabled} maxLength={50} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <NumericInput
              name="verificacion_tecnica_vehicular"
              label="Verificación Técnica Vehícular"
              disabled={disabled}
            />
          </Col>
          <Col span={8}>
            <Form.Item
              name="estatus_del_vehiculo"
              label="Estatus del Vehículo"
              rules={rules.required}
            >
              <Select
                dataSource={estadosDelVehiculo}
                labelProp="nombre"
                disabled
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="fecha_de_repuve"
              label="Fecha de Repuve"
              hasFeedback
              rules={rules?.required}
            >
              <DatePicker
                placeholder=""
                format={DATE_FRONTEND_FORMAT}
                disabled={disabled}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="clave_de_repuve"
              label="Clave de Repuve"
              hasFeedback
            >
              <Input
                allowClear
                disabled={disabled}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="descripcion_de_la_agencia"
              label="Agencia Distribuidora"
              rules={rules.required}
            >
              <Input.TextArea
                autoSize={{ minRows: 3, maxRows: 3 }}
                allowClear
                disabled={disabled}
              />
            </Form.Item>
          </Col>
          <Col span={24} />
          <Typography.Title level={3} style={{ marginTop: 30 }}>
            Facturación
          </Typography.Title>
          <Col span={24} />
          <Col span={8}>
            <Form.Item
              name="clave_del_documento_de_regularizacion"
              label="Clave de Documento"
            >
              <Select
                disabled={disabled}
                dataSource={clavesDeDocumento}
                keyLabelRender
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="documentos_de_tramite"
              label="Documento del Trámite"
            >
              <Select
                dataSource={documentoTramite}
                keyLabelRender
                keyProp="clave"
                labelProp="descripcion"
                mode="multiple"
                disabled={disabled}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="es_vehiculo_nacional"
              label="¿Es Nacional?"
              rules={rules.required}
            >
              <Select disabled={disabled} trueFalse />
            </Form.Item>
          </Col>
          {!esNacional && (
            <Col span={8}>
              <Form.Item
                name="pais"
                label="País"
              >
                <Select
                  dataSource={paises.current}
                  disabled={disabled}
                  pagination={{
                    getter: getCatalogoDePaises,
                    setter: (dataSource) => {
                      paises.current = dataSource;
                    },
                    config: { auto: true, qName: 'descripcion' },
                  }}
                />
              </Form.Item>
            </Col>
          )}
          <Col span={8}>
            <NumericInput
              name="importe_de_la_factura"
              label="Importe de la factura"
              disabled={disabled}
              decimal
              required
            />
          </Col>
          <Col span={8}>
            <Form.Item
              name="fecha_de_la_factura"
              label="Fecha de la Factura"
              rules={rules.required}
            >
              <DatePicker
                placeholder=""
                format={DATE_FRONTEND_FORMAT}
                disabled={disabled}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="numero_de_factura"
              label="Nofac"
              normalize={capitalize}
              rules={[...rules.required, ...rules.slug, maxRule(50)]}
              tooltip="Letras, números, guiones y guiones bajos"
            >
              <Input allowClear disabled={disabled} maxLength={50} />
            </Form.Item>
          </Col>
          {!isBaja && (
          <Col span={8}>
            <Form.Item
              name="rfc_emisor_cfdi"
              label="RFC Emisor CFDI"
              rules={rules.required}
              normalize={noSymbolsCapitalized}
            >
              <Input allowClear disabled={isCambio} maxLength={13} />
            </Form.Item>
          </Col>
          )}
            {(isCambio && !vehiculo?.hasRFC) && (
            <>
              <Col xs={24} sm={24} md={8}>
                <Button
                  onClick={() => {
                    setVisibleWidgetRFC(true);
                  }}
                  block
                  style={{ marginTop: 21 }}

                >
                  Agregar RFC emisor
                </Button>
              </Col>
            </>
            )}
          <Col span={8}>
            <Form.Item
              name="registro_publico_vehicular"
              label="Registro Público Vehícular"
              normalize={capitalize}
              rules={[maxRule(17)]}
            >
              <Input allowClear maxLength={17} disabled={disabled} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="observaciones"
              label="Observaciones"
              normalize={capitalize}
            >
              <Input.TextArea
                autoSize={{ minRows: 3, maxRows: 3 }}
                allowClear
                disabled={disabled}
              />
            </Form.Item>
          </Col>
          {!disabled && (
            <SaveButton />
          )}
        </>
      )}
    </>
  );

  const AddRemolque = ({ disabled }) => (
    <>
      <SearchVehiculoEnBaja visible={!vehiculo} />
      {((isAlta || vehiculo) || ((!vehiculo && isDeOtroEstado))) && (
        <>
          <Col span={24}>
            <Typography.Title level={3}>
              {`Alta ${padronVehicularLabel}`}
            </Typography.Title>
          </Col>
          <Col span={8}>
            <Form.Item
              label="Propietario"
              name="object_id_propietario"
              rules={rules.required}
            >
              <Select
                render={(e) => padronToString(e, tipoDePadronPropietario)}
                dataSource={[propietario]}
                allowClear={false}
                showArrow={false}
                disabled
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              label="Serie"
              name="serie"
              normalize={toUpper}
              rules={[...rules.required, maxRule(17)]}
              maxLength={17}
            >
              <Input allowClear disabled={disabled} />
            </Form.Item>
          </Col>
          {isDeOtroEstado ? (
            <>
              <Col xs={24} sm={24} md={8}>
                <Button
                  onClick={() => {
                    setVisiblePlaca(true);
                  }}
                  block
                  style={{ marginTop: 21 }}
                  disabled={!vehiculo}
                >
                  Agregar Placa
                </Button>
              </Col>
              <Col span={8}>
                <Form.Item
                  name="placa"
                  label="Número de Placa"
                  rules={(isDeOtroEstado && vehiculo) ? rules.required : null}
                  normalize={noSymbolsCapitalized}
                >
                  <Input disabled />
                </Form.Item>
              </Col>
            </>
          ) : (
            <>
              <Col span={8}>
                <Form.Item
                  name="placa"
                  label="Número de Placa"
                  normalize={noSymbolsCapitalized}
                >
                  <Input disabled placeholder="Por asignar" />
                </Form.Item>
              </Col>
            </>
          )}
          <Col span={8}>
            <Form.Item
              name="tarjeta_de_circulacion"
              normalize={toUpper}
              label="Número de Tarjeta de Circulación"
            >
              <Input allowClear disabled={disabled} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="numero_calcomania"
              label="Número de Calcomanía"
            >
              <Input allowClear disabled={disabled} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="clave_nacional"
              label="Clave Nacional"
            >
              <Input allowClear disabled={disabled} />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              name="unidad_de_recaudacion"
              label="Unidad Recaudadora"
              rules={rules.required}
            >
              <Select
                dataSource={unidadesDeRecaudacion}
                disabled={disabled}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="es_vehiculo_nacional"
              label="¿Es Nacional?"
            >
              <Select trueFalse disabled={disabled} />
            </Form.Item>
          </Col>
          {!esNacional && (
            <Col span={8}>
              <Form.Item
                name="pais"
                label="País"
              >
                <Select
                  dataSource={paises.current}
                  disabled={disabled}
                  pagination={{
                    getter: getCatalogoDePaises,
                    setter: (dataSource) => {
                      paises.current = dataSource;
                    },
                    config: { auto: true, qName: 'descripcion' },
                  }}
                />
              </Form.Item>
            </Col>
          )}
          <Col span={8}>
            <Form.Item
              name="marca"
              label="Marca"
              rules={rules.required}
            >
              <Select
                dataSource={marcasTemp.results.length ? marcasTemp : marcas.current}
                usingExternalDataSource={Boolean(marcasTemp.results.length)}
                disabled={disabled}
                onClear={() => {
                  if (marcasTemp.results.length) {
                    setMarcasTemp({ results: [] });
                  }
                }}
                pagination={{
                  getter: getMarcasDeRemolques,
                  setter: (dataSource) => {
                    marcas.current = dataSource;
                  },
                  config: {
                    auto: true,
                    qName: 'descripcion',
                    selfValue: marca,
                  },
                }}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <NumericInput
              name="modelo"
              label="Modelo"
              tooltip="Año del vehículo"
              required
              maxLength={4}
              minLength={4}
              disabled={disabled}
            />
          </Col>
          <Col span={8}>
            <Form.Item
              name="linea"
              label="Línea"
            >
              <Input allowClear disabled={disabled} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="tipo"
              label="Tipo de Remolque"
            >
              <Input allowClear disabled={disabled} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="estatus_del_vehiculo"
              label="Estatus del Remolque"
              rules={rules.required}
            >
              <Select
                dataSource={estadosDelVehiculo}
                labelProp="nombre"
                disabled
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="servicio"
              label="Servicio"
              rules={rules.required}
            >
              <Select dataSource={servicios} labelProp="nombre" disabled={disabled} />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8}>
            <NumericInput
              decimal
              name="ancho_del_remolque"
              label="Ancho del Remolque"
              disabled={disabled}
              required
            />
          </Col>
          <Col xs={24} sm={24} md={8}>
            <NumericInput
              decimal
              name="alto_del_remolque"
              label="Altura del Remolque"
              disabled={disabled}
              required
            />
          </Col>
          <Col xs={24} sm={24} md={8}>
            <NumericInput
              decimal
              name="largo_del_remolque"
              label="Largo del Remolque"
              disabled={disabled}
              required
            />
          </Col>
          <Col span={8}>
            <Form.Item
              name="color_del_remolque"
              label="Color"
              rules={rules.required}
            >
              <Select
                dataSource={colores}
                disabled={disabled}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="color_secundario"
              label="Color Secundario"
              rules={rules.required}
            >
              <Input
                allowClear
                disabled={disabled}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="uso_del_remolque"
              label="Uso del Remolque"
              rules={rules.required}
            >
              <Select dataSource={usosRemolques} disabled={disabled} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <NumericInput
              name="numero_de_ruedas"
              label="Número de Ruedas"
              disabled={disabled}
              required
            />
          </Col>
          <Col span={8}>
            <Form.Item
              name="capacidad_de_carga"
              label="Capacidad en Peso"
            >
              <Input allowClear disabled={disabled} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="fecha_de_repuve"
              label="Fecha de Repuve"
              hasFeedback
              rules={rules?.required}
            >
              <DatePicker
                placeholder=""
                format={DATE_FRONTEND_FORMAT}
                disabled={disabled}
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              name="observaciones"
              label="Observaciones"
            >
              <Input.TextArea
                allowClear
                autoSize={{ minRows: 3, maxRows: 3 }}
                disabled={disabled}
              />
            </Form.Item>
          </Col>
          <Typography.Title level={3} style={{ marginTop: 30 }}>
            Facturación
          </Typography.Title>
          <Col span={24} />
          <Col span={8}>
            <NumericInput
              name="importe_de_la_factura"
              label="Importe de la factura"
              disabled={disabled}
              decimal
              required
            />
          </Col>
          <Col span={8}>
            <Form.Item
              name="fecha_de_la_factura"
              label="Fecha de la Factura"
              rules={rules.required}
            >
              <DatePicker
                placeholder=""
                format={DATE_FRONTEND_FORMAT}
                disabled={disabled}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="numero_de_factura"
              label="Nofac"
              normalize={capitalize}
              rules={[...rules.required, ...rules.slug, maxRule(50)]}
              tooltip="Letras, números, guiones y guiones bajos"
            >
              <Input allowClear disabled={disabled} maxLength={50} />
            </Form.Item>
          </Col>
          {!isBaja && (
          <Col span={8}>
            <Form.Item
              name="rfc_emisor_cfdi"
              label="RFC Emisor CFDI"
              rules={rules.required}
              normalize={noSymbolsCapitalized}
            >
              <Input allowClear disabled={isCambio} maxLength={13} />
            </Form.Item>
          </Col>
          )}
            {(isCambio && !vehiculo?.hasRFC) && (
            <>
              <Col xs={24} sm={24} md={8}>
                <Button
                  onClick={() => {
                    setVisibleWidgetRFC(true);
                  }}
                  block
                  style={{ marginTop: 21 }}

                >
                  Agregar RFC emisor
                </Button>
              </Col>
            </>
            )}
          {!disabled && (
            <SaveButton />
          )}
        </>
      )}
    </>
  );

  const AddMoto = ({ disabled }) => (
    <>
      <SearchVehiculoEnBaja visible={!vehiculo} />
      {((isAlta || vehiculo) || (isDeOtroEstado && !tramite)) && (
        <>
          <Col span={24}>
            <Typography.Title level={3}>
              {`Alta ${padronVehicularLabel}`}
            </Typography.Title>
          </Col>
          <Col span={8}>
            <Form.Item
              label="Propietario"
              name="object_id_propietario"
              rules={rules.required}
            >
              <Select
                render={(e) => padronToString(e, tipoDePadronPropietario)}
                dataSource={[propietario]}
                allowClear={false}
                showArrow={false}
                disabled
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              label="Serie"
              name="serie"
              normalize={toUpper}
              rules={[...rules.required, maxRule(17)]}
              maxLength={17}
            >
              <Input allowClear disabled={disabled} />
            </Form.Item>
          </Col>
          {isDeOtroEstado ? (
            <>
              <Col xs={24} sm={24} md={8}>
                <Button
                  onClick={() => {
                    setVisiblePlaca(true);
                  }}
                  block
                  style={{ marginTop: 21 }}
                  disabled={!vehiculo}
                >
                  Agregar Placa
                </Button>
              </Col>
              <Col span={8}>
                <Form.Item
                  name="numero_de_placa_vigente"
                  label="Número de Placa"
                  rules={(isDeOtroEstado && vehiculo) ? rules.required : null}
                  normalize={noSymbolsCapitalized}
                >
                  <Input disabled />
                </Form.Item>
              </Col>
            </>
          ) : (
            <>
              <Col span={8}>
                <Form.Item
                  name="numero_de_placa_vigente"
                  label="Número de Placa"
                  normalize={noSymbolsCapitalized}
                >
                  <Input disabled placeholder="Por asignar" />
                </Form.Item>
              </Col>
            </>
          )}
          <Col span={8}>
            <Form.Item
              name="tarjeta_de_circulacion"
              normalize={toUpper}
              label="Número de Tarjeta de Circulación"
            >
              <Input allowClear disabled={disabled} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="numero_calcomania"
              label="Número de Calcomanía"
            >
              <Input allowClear disabled={disabled} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="clave_nacional"
              label="Clave Nacional"
            >
              <Input allowClear disabled={disabled} />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              name="unidad_de_recaudacion"
              label="Unidad Recaudadora"
              rules={rules.required}
            >
              <Select
                dataSource={unidadesDeRecaudacion}
                disabled={disabled}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="tipo_de_tramite_vehicular"
              label="Tipo de trámite vehícular"
            >
              <Select dataSource={tiposDeTramites} disabled={disabled} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="es_vehiculo_nacional"
              label="¿Es Nacional?"
            >
              <Select trueFalse disabled={disabled} />
            </Form.Item>
          </Col>
          {!esNacional && (
            <Col span={8}>
              <Form.Item
                name="pais"
                label="País"
              >
                <Select
                  dataSource={paises.current}
                  disabled={disabled}
                  pagination={{
                    getter: getCatalogoDePaises,
                    setter: (dataSource) => {
                      paises.current = dataSource;
                    },
                    config: { auto: true, qName: 'descripcion' },
                  }}
                />
              </Form.Item>
            </Col>
          )}
          <Col span={8}>
            <Form.Item
              name="es_fronterizo"
              label="¿Es Fronterizo?"
            >
              <Select trueFalse disabled={disabled} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="marca"
              label="Marca"
              rules={rules.required}
            >
              <Select
                dataSource={marcasTemp.results.length ? marcasTemp : marcas.current}
                usingExternalDataSource={Boolean(marcasTemp.results.length)}
                disabled={disabled}
                onClear={() => {
                  if (marcasTemp.results.length) {
                    setMarcasTemp({ results: [] });
                  }
                }}
                pagination={{
                  getter: getMarcasDeMotocicletas,
                  setter: (dataSource) => {
                    marcas.current = dataSource;
                  },
                  config: {
                    auto: true,
                    qName: 'descripcion',
                    selfValue: marca,
                  },
                }}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <NumericInput
              name="modelo"
              label="Modelo"
              tooltip="Año del vehículo"
              required
              maxLength={4}
              minLength={4}
              disabled={disabled}
            />
          </Col>
          <Col span={8}>
            <Form.Item
              name="linea"
              label="Submarca"
              rules={rules?.required}
            >
              <Input allowClear disabled={disabled} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="tipo_de_motocicleta"
              label="Tipo de Motocicleta"
              rules={rules.required}
            >
              <Select labelProp="nombre" dataSource={tiposDeMotocicletas} disabled={disabled} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="estatus_del_vehiculo"
              label="Estatus de la motocicleta"
              rules={rules.required}
            >
              <Select
                dataSource={estadosDelVehiculo}
                labelProp="nombre"
                disabled
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="servicio"
              label="Servicio"
              rules={rules.required}
            >
              <Select dataSource={servicios} labelProp="nombre" disabled={disabled} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="numero_de_motor"
              label="Número de motor"
            >
              <Input allowClear disabled={disabled} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="descripcion_de_la_agencia"
              label="Agencia Distribuidora"
              rules={rules.required}
            >
              <Input allowClear disabled={disabled} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="color_del_vehiculo"
              label="Color Primario"
            >
              <Select
                dataSource={colores}
                disabled={disabled}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="color_secundario"
              label="Color Secundario"
              rules={rules.required}
            >
              <Input
                allowClear
                disabled={disabled}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <NumericInput
              name="capacidad_del_combustible"
              label="Capacidad del Tanque"
              disabled={disabled}
              tooltip="Capacidad en litros"
            />
          </Col>
          <Col span={8}>
            <Form.Item
              name="uso_de_la_motocicleta"
              label="Uso de la Motocicleta"
              rules={rules.required}
            >
              <Select dataSource={usos} disabled={disabled} />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8}>
            <NumericInput
              name="capacidad_del_cilindraje"
              label="Desplazamiento (cc/L)"
              disabled={disabled}
              decimal
              required
            />
          </Col>
          <Col span={8}>
            <NumericInput
              name="cilindraje"
              label="Cilindraje"
              disabled={disabled}
              decimal
              required
            />
          </Col>
          <Col span={8}>
            <NumericInput
              name="peso_del_vehiculo"
              label="Peso de la Motocicleta"
              disabled={disabled}
              decimal
              tooltip="Peso en Kilogramos"
            />
          </Col>
          <Col span={8}>
            <NumericInput
              name="numero_de_ruedas"
              label="Número de Ruedas"
              disabled={disabled}
              required
            />
          </Col>
          <Col span={8}>
            <Form.Item
              name="tipo_de_combustible"
              label="Tipo de Combustible"
              rules={rules.required}
            >
              <Select dataSource={tipoDeCombustible} disabled={disabled} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="fecha_de_repuve"
              label="Fecha de Repuve"
              hasFeedback
              rules={rules?.required}
            >
              <DatePicker
                placeholder=""
                format={DATE_FRONTEND_FORMAT}
                disabled={disabled}
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              name="observaciones"
              label="Observaciones"
            >
              <Input.TextArea
                allowClear
                autoSize={{ minRows: 3, maxRows: 3 }}
                disabled={disabled}
              />
            </Form.Item>
          </Col>
          <Typography.Title level={3} style={{ marginTop: 30 }}>
            Facturación
          </Typography.Title>
          <Col span={24} />
          <Col span={8}>
            <NumericInput
              name="importe_de_la_factura"
              label="Importe de la factura"
              disabled={disabled}
              decimal
              required
            />
          </Col>
          <Col span={8}>
            <Form.Item
              name="fecha_de_la_factura"
              label="Fecha de la Factura"
              rules={rules.required}
            >
              <DatePicker
                placeholder=""
                format={DATE_FRONTEND_FORMAT}
                disabled={disabled}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="numero_de_factura"
              label="Nofac"
              normalize={capitalize}
              rules={[...rules.required, ...rules.slug, maxRule(50)]}
              tooltip="Letras, números, guiones y guiones bajos"
            >
              <Input allowClear disabled={disabled} maxLength={50} />
            </Form.Item>
          </Col>
          {!isBaja && (
          <Col span={8}>
            <Form.Item
              name="rfc_emisor_cfdi"
              label="RFC Emisor CFDI"
              rules={rules.required}
              normalize={noSymbolsCapitalized}
            >
              <Input allowClear disabled={isCambio} maxLength={13} />
            </Form.Item>
          </Col>
          )}
            {(isCambio && !vehiculo?.hasRFC) && (
            <>
              <Col xs={24} sm={24} md={8}>
                <Button
                  onClick={() => {
                    setVisibleWidgetRFC(true);
                  }}
                  block
                  style={{ marginTop: 21 }}

                >
                  Agregar RFC emisor
                </Button>
              </Col>
            </>
            )}
          {!disabled && (
            <SaveButton />
          )}
        </>
      )}
    </>
  );

  const AddPadronVehicular = ({ disabled }) => {
    if (tipoDePadronVehicular === 4) {
      return (
        <AddVehiculo disabled={disabled} />
      );
    }
    if (tipoDePadronVehicular === 16) {
      return (
        <AddMoto disabled={disabled} />
      );
    }
    return (
      <AddRemolque disabled={disabled} />
    );
  };

  const renderCapturaDeImporte = (tc) => {
    const disabled = !selectedKeys.includes(tc.id);
    if (tc.tipo_de_aplicacion === 1) {
      return (
        <Form.Item
          label={`Importe ${(tc.importe_minimo || tc.importe_maximo) && `(${tc.importe_minimo} - ${tc.importe_maximo})`}`}
          name={[tc.id, 'importe']}
          rules={[
            required,
            {
              validator: async (_, value) => {
                if (value) {
                  if (!decimalRegExp.test(value)) {
                    throw new Error('Ingrese un decimal válido');
                  }
                  if (value < tc.importe_minimo) {
                    throw new Error('Ingrese una cantidad mayor al importe mínimo del cargo');
                  }
                  if (value > tc.importe_maximo) {
                    throw new Error('Ingrese una cantidad menor al importe máximo del cargo');
                  }
                }
              },
            },
          ]}
          normalize={(val) => decimalNormalizer(val)}
        >
          <Input disabled={disabled} />
        </Form.Item>
      );
    }
    // TODO: Por revisar a fondo, nayarit no usa tarifa actualmente
    if (tc.tipo_de_aplicacion === 3 || tc.tipo_de_aplicacion === 5) {
      const tipoDeDato = tc.tipo_de_dato?.id || tc.tipo_de_dato;
      return (
        <Form.Item
          name={[tc.id, tc.catalgo_de_tarifa ? 'variable' : 'importe']}
          label={`Introduzca ${tc.parametro_descripcion}`}
          rules={tipoDeDato === 3 ? rules.required : (rules[tipoDeDato === 1 ? 'integer' : 'decimal'])}
          normalize={(val) => {
            if (tipoDeDato === 1) {
              return toInteger(val);
            }
            if (tipoDeDato === 2) {
              return decimalNormalizer(val);
            }
            return val;
          }}
        >
          {tipoDeDato === 3 ? (
            <DatePicker.RangePicker
              disabled={disabled}
              disabledDate={(date) => date.isAfter(new Date())}
            />
          ) : (
            <Input disabled={disabled} allowClear />
          )}
        </Form.Item>
      );
    }

    return tc.variables.map((v) => {
      const variable = variables.find((item) => item.id === v);
      return (
        <Col
          xs={24}
          sm={24}
          md={8}
          key={variable.nombre}
        >
          <Form.Item
            label={variable.descripcion_de_la_variable}
            name={[tc.id, variable.nombre]}
            rules={tc.tipo_de_variable === 3 ? rules.required : (rules[tc.tipo_de_variable === 1 ? 'integer' : 'decimal'])}
            normalize={(val) => {
              if (variable.tipo_de_variable === 1) {
                return toInteger(val);
              }
              if (variable.tipo_de_variable === 2) {
                return decimalNormalizer(val);
              }
              return val;
            }}
          >
            {variable.tipo_de_variable === 3 ? (
              <DatePicker.RangePicker
                disabled={disabled}
                disabledDate={(date) => date.isAfter(new Date())}
              />
            ) : (
              <Input allowClear disabled={disabled} />
            )}
          </Form.Item>
        </Col>
      );
    });
  };

  const onChangeSelectedKeys = (checked, key) => {
    if (checked) {
      setSelectedKeys([...selectedKeys, key]);
    } else if (selectedKeys.length > 1 || cargosGenerados.length) {
      setSelectedKeys(selectedKeys.filter((e) => e !== key));
    }
  };

  const Folio = () => (
    <>
      <Typography.Title level={3}>
        Folio de Trámite:
        {' '}
        <Typography.Text className="primary-text" copyable>{tramite.folio}</Typography.Text>
      </Typography.Title>
      <Col span={24} />
    </>
  );

  const imprimirOrdenDePago = async () => {
    setLoading(true);
    base64.current[VISIBLE_PREVIEW_ENUM.ORDEN_DE_PAGO] = null;
    const updateAdeudo = await postConsultarCargosPorPadron(tipoDePadronVehicular, vehiculo?.id);
    const idsTramites = tramite.cargos.map(mapId);
    const updatedCargos = updateAdeudo?.cargos.filter((i) => idsTramites.includes(i.id));
    if (updateAdeudo) {
      if (!base64.current[VISIBLE_PREVIEW_ENUM.ORDEN_DE_PAGO]) {
        const normalized = normalizeCargos(updatedCargos);
        const amount = round(normalized
          .reduce((acum, curr) => acum + (curr?.adeudo_total), 0));
        const lastDayInstance = toMoment(new Date()).endOf('month');
        const fechaBilling = lastDayInstance.format(DATE_FORMAT);
        const fecha = lastDayInstance.format(DATE_NETPAY_FORMAT);
        const esCambio = MAP_IDS_POR_TIPO_DE_TRAMITE.CAMBIO.includes(tipoDeTramite.id);
        const _propietario = esCambio ? propietarioNuevo : propietario;
        const _tipoDePadronPropietario = esCambio
          ? tipoDePadronPropietarioNuevo : tipoDePadronPropietario;
        const ciudadano = _tipoDePadronPropietario === 1
          ? _propietario?.id
          : _propietario?.ciudadano;
        const result = await postImprimirOrdenDePago(
          amount,
          fecha,
          fechaBilling,
          idsTramites,
          vehiculo.id,
          tipoDePadronVehicular,
          ciudadano,
        );
        if (result.success) {
          base64.current[VISIBLE_PREVIEW_ENUM.ORDEN_DE_PAGO] = result.base64;
          setVisiblePreview(VISIBLE_PREVIEW_ENUM.ORDEN_DE_PAGO);
        }
      } else {
        setVisiblePreview(VISIBLE_PREVIEW_ENUM.ORDEN_DE_PAGO);
      }
      setLoading(false);
    }
  };

  const Pago = () => (tramite.cargosSaldados ? (
    <Typography.Text>
      Los cargos han sido saldados. Puede continuar el proceso
    </Typography.Text>
  ) : (
    <>
      <Folio />
      <Typography.Text>
        Se han generado los cargos correspondientes.
      </Typography.Text>
      <Col span={24} />
      <Typography.Text>
        Favor de pasar a cajas a saldar la
        deuda y vuelva con su
        {' '}
        <Typography.Text className="primary-text">FOLIO</Typography.Text>
        {' '}
        para continuar con su proceso.
      </Typography.Text>
      <Col span={24} />
      <Typography.Text>
        O puede solicitar una orden de pago.
      </Typography.Text>
      <Col span={24} />
      <br />
      <br />
      <Col span={8}>
        <Button block onClick={imprimirOrdenDePago}>
          Imprimir Orden de Pago
        </Button>
      </Col>
    </>
  ));

  const label = tipoDeTramite?.descripcion;
  const getFormatoTramiteMap = {
    4: (id, _tramite) => getFormatoTramitePDF({ vehiculo_id: id, tramite: _tramite, label }),
    16: (id, _tramite) => getFormatoTramitePDF({ motocicleta_id: id, tramite: _tramite, label }),
    17: (id, _tramite) => getFormatoTramitePDF({ remolque_id: id, tramite: _tramite, label }),
  };

  const getFormatoTramite = async () => {
    setLoading(true);
    base64.current[VISIBLE_PREVIEW_ENUM.FORMATO_ALTA] = null;
    const updateCargos = await postConsultarCargosPorPadron(tipoDePadronVehicular, vehiculo?.id);
    if (updateCargos) {
      if (!base64.current[VISIBLE_PREVIEW_ENUM.FORMATO_ALTA]) {
        const formatoAlta = await getFormatoTramiteMap[tipoDePadronVehicular](
          vehiculo?.id,
          tramite.id,
        );
        if (formatoAlta) {
          base64.current[VISIBLE_PREVIEW_ENUM.FORMATO_ALTA] = formatoAlta;
          setVisiblePreview(VISIBLE_PREVIEW_ENUM.FORMATO_ALTA);
        }
      } else {
        setVisiblePreview(VISIBLE_PREVIEW_ENUM.FORMATO_ALTA);
      }
      setLoading(false);
    }
  };

  const periodos = useMemo(() => {
    if (tipoDeTramite) {
      const diff = [...new Set(tipoDeTramite.tiposDeCargos.map((tc) => tc.periodo_fiscal))];
      const mapped = diff.map((id) => {
        const _periodo = periodosFiscales.find((pf) => pf.id === id);
        return ({ value: _periodo.id, label: _periodo.periodo, disabled: _periodo.vigente });
      });
      setPeriodosSeleccionados(mapped.filter((p) => p.disabled).map((e) => e.value));
      return mapped;
    }
    return [];
  }, [tipoDeTramite]);

  const ButtonStartTramite = () => (
    <Col span={24}>
      <Row justify="end">
        <Col span={6}>
          <Button
            block
            htmlType="submit"
            className="btn-tramite-wizard no-color"
            shape="round"
            disabled={loading || loadingAdeudo}
          >
            Iniciar Trámite
          </Button>
        </Col>
      </Row>
    </Col>
  );

  const ComenzarTramite = () => {
    if (tramite) {
      return (
        <>
          <Folio />
          {(!tramitePortalReemplacamiento || !tramitePortal) && (
          <Col span={8}>
            <Button block onClick={getFormatoTramite}>
              Imprimir formato de trámite
            </Button>
          </Col>
          )}
        </>
      );
    }
    return (
      <>
        {(!tramitePortal && !tramitePortalReemplacamiento) && (
        <>
          <Typography.Text>
            Al iniciar el trámite se registrarán los siguientes cargos:
          </Typography.Text>
          <Col span={24} />
          <Checkbox.Group
            options={periodos}
            value={periodosSeleccionados}
            onChange={(checked) => setPeriodosSeleccionados(checked)}
          />
          {tipoDeTramite.tiposDeCargos
            .filter(((e) => periodosSeleccionados.includes(e.periodo_fiscal))).map((tc) => {
              const disabled = cargosGenerados.some((e) => e.tipo_de_cargo?.id === tc.id);
              return (
                <Col span={24} key={tc.id}>
                  <div>
                    <Checkbox
                      onChange={({ target: { checked } }) => onChangeSelectedKeys(checked, tc.id)}
                      checked={selectedKeys.includes(tc.id)}
                      style={{ marginRight: 10 }}
                      disabled={disabled}
                    />
                    <Typography.Text
                      delete={!selectedKeys.includes(tc.id) && !disabled}
                      onClick={() => onChangeSelectedKeys(!selectedKeys.includes(tc.id), tc.id)}
                      style={{ cursor: selectedKeys.length === 1 && tc.id === selectedKeys[0] && !cargosGenerados.length ? 'not-allowed' : 'pointer' }}
                      type={disabled ? 'success' : ''}
                    >
                      {`${periodosFiscales.find((e) => e.id === tc.periodo_fiscal)?.periodo} - ${tc.clave} - ${tc.descripcion}`}
                    </Typography.Text>
                  </div>
                  {selectedKeys.includes(tc.id) && ![2, 6].includes(tc.tipo_de_aplicacion)
                  && renderCapturaDeImporte(tc)}
                </Col>
              );
            })}
        </>
        )}
        {(tramitePortal || tramitePortalReemplacamiento) && (
          <>
            <Typography.Text>
              Estas a punto de iniciar el tramite, si lo consideras puedes dejar un comentario aqui:
            </Typography.Text>
            <Col span={24} />
          </>
        )}
        <Col span={24} style={{ height: 150, marginTop: 30 }}>
          <Form.Item label="Comentarios" name="comentarios_del_tramite">
            <Input.TextArea autoSize={{ minRows: 4, maxRows: 4 }} />
          </Form.Item>
        </Col>
        <ButtonStartTramite />
      </>
    );
  };
  useEffect(() => {
    if (useAutoAssing && tramiteEnProceso
      && currentStep === 4
      && (isAlta
        || isCambio
        || isRefrendoReemplacamiento
        || isRefrendoReemplacamientoManual
        || tramitePortalReemplacamiento)) {
      if (!(vehiculo?.numero_de_placa_vigente || vehiculo?.placa)) {
        getPlacasSiguientes();
      } else if (tipoDePadronVehicular !== 17) {
        form.setFieldsValue({ numero_de_placa_vigente: vehiculo?.numero_de_placa_vigente });
      } else {
        form.setFieldsValue({ placa: (vehiculo?.placa || vehiculo?.numero_de_placa_vigente) });
      }
    } else if (
      useAutoAssing && (tramiteEnProceso || tramiteFinalizado)
      && (isDotacionDePlacas || isRefrendoReemplacamientoManual || tramitePortalReemplacamiento)
      && (tipoDePadronPropietario === 1 ? currentStep === 5 : currentStep === 4)) {
      if (!(vehiculo?.numero_de_placa_vigente || vehiculo?.placa)) {
        getPlacasSiguientes();
      } else if (tipoDePadronVehicular !== 17) {
        form.setFieldsValue({ numero_de_placa_vigente: vehiculo?.numero_de_placa_vigente });
      } else {
        form.setFieldsValue({ placa: (vehiculo?.placa || vehiculo?.numero_de_placa_vigente) });
      }
    }
  }, [currentStep]);

  const AsignacionDePlacas = () => (
    <>
      <Col span={24}>
        <Typography.Title level={3}>
          {`Capture las placa para el ${padronVehicularLabel}`}
        </Typography.Title>
      </Col>
      {(useAutoAssing && tramiteEnProceso && !permitirPlacaManual) && (
        <Col span={8}>
          <Form.Item label="Configuración de asignación" name="confAsigPlaca">
            <Select
              dataSource={configsAsigPlacas}
              labelProp="descripcion"
              onChange={(val) => {
                if (val) {
                  const match = configsAsigPlacas.find((e) => e.id === val);
                  form.setFieldsValue({ numero_de_placa_vigente: match.numero_de_placa_siguiente });
                } else {
                  form.resetFields(['numero_de_placa']);
                }
              }}
              disabled={tipoDePadronVehicular === 4 || vehiculo.numero_de_placa_vigente
                || vehiculo.placa}
            />
          </Form.Item>
        </Col>
      )}
      <Col span={8}>
        <Form.Item
          name={tipoDePadronVehicular !== 17 ? 'numero_de_placa_vigente' : 'placa'}
          label="Número de Placa"
          rules={rules.numero_de_placa_vigente}
          normalize={noSymbolsCapitalized}
        >
          <Input
            allowClear
            maxLength={10}
            disabled={
              !!vehiculo?.placa
              || !!vehiculo?.numero_de_placa_vigente
              || (useAutoAssing && !permitirPlacaManual)
            }
          />
        </Form.Item>
      </Col>
      {useAutoAssing && !configsAsigPlacas.length && !tramiteFinalizado && (
      <Col xs={24} sm={24} md={8}>
        <Form.Item
          name="permiteplacamanual"
          valuePropName="checked"
          style={{ marginTop: 21 }}
        >
          <Checkbox>
            Asignar Placa Manualmente
          </Checkbox>
        </Form.Item>
      </Col>
      )}
      {!(tipoDePadronVehicular !== 17 ? vehiculo?.numero_de_placa_vigente : vehiculo?.placa) ? (
        <SaveButton />
      ) : (
        <Col span={8}>
          <Form.Item style={{ marginTop: 22 }}>
            {/* eslint-disable-next-line no-use-before-define */}
            <Button block onClick={() => getRecibo()}>
              Imprimir recibo
            </Button>
          </Form.Item>
        </Col>
      )}
    </>
  );

  const getRecibo = async (cargoId = tramite?.cargos[0]?.id, show = true) => {
    if (!base64.current[VISIBLE_PREVIEW_ENUM.RECIBO]) {
      const recibo = await getReciboPDFDeTramite(cargoId);
      if (recibo) {
        base64.current[VISIBLE_PREVIEW_ENUM.RECIBO] = recibo.base64;
        if (show) {
          setVisiblePreview(VISIBLE_PREVIEW_ENUM.RECIBO);
        }
        return recibo.folio?.[0] || recibo.id;
      }
      message.warn('No fue posible consultar el recibo');
    } else {
      setVisiblePreview(VISIBLE_PREVIEW_ENUM.RECIBO);
    }
    return null;
  };

  const getFormatoDeDestruccion = async (show = false, _paramValues) => {
    if (!base64.current[VISIBLE_PREVIEW_ENUM.FORMATO_BAJA]) {
      const _values = tramiteFinalizado ? tramite.placa : _paramValues;
      if (_values) {
        const values = {
          ID: 78,
          Parametros: [
            {
              Nombre: 'placa',
              TipoParametro: 'Texto',
              Valor: _values.numero_de_placa,
            },
            {
              Nombre: 'entidad',
              TipoParametro: 'Texto',
              Valor: estados.find((e) => e.id === _values.estado)?.nombre_de_AGEE,
            },
            {
              Nombre: 'recibo',
              TipoParametro: 'Texto',
              Valor: _values.folio_de_recibo?.toString() || tramite.folio,
            },
            {
              Nombre: 'documento',
              TipoParametro: 'Texto',
              Valor: _values.folio_de_documento_de_denuncia || '',
            },
            {
              Nombre: 'numero_de_placas_fisicas',
              TipoParametro: 'Texto',
              Valor: _values.cantidad_de_placas?.toString(),
            },
            {
              Nombre: 'fecha_y_hora',
              TipoParametro: 'Texto',
              Valor: toMoment(tramite?.fecha_de_finalizacion)?.format(`${DATE_FORMAT.replace(/-/g, '/')} ${TIME_FORMAT}`)
              || moment().format(`${DATE_FORMAT.replace(/-/g, '/')} ${TIME_FORMAT}`),
            },
            {
              Nombre: 'folio',
              TipoParametro: 'Texto',
              Valor: tramite.folio,
            },
            // TODO el codigo de barras como se va utilizar y que mandar
            {
              Nombre: 'codigo_de_barras',
              TipoParametro: 'Texto',
              Valor: 'codigodebarras',
            },
          ],
        };
        const _formato = await postObtenerReporte(values);
        if (_formato) {
          base64.current[VISIBLE_PREVIEW_ENUM.FORMATO_BAJA] = _formato;
          if (show) {
            setVisiblePreview(VISIBLE_PREVIEW_ENUM.FORMATO_BAJA);
          }
        }
      } else {
        message.info('No se encontró la información necesaria para obtener el formato');
      }
    } else {
      setVisiblePreview(VISIBLE_PREVIEW_ENUM.FORMATO_BAJA);
    }
  };

  const finishTramite = async () => {
    setLoading(true);
    const saved = await patchTramite(tramite.id, { estados_globales: 4 });
    await searchTramite(tramite.folio);
    setLoading(false);
    if (saved) {
      tramite.fecha_de_finalizacion = saved.fecha_de_finalizacion;
      await getRecibo();
    }
    return saved;
  };

  const imprimirTarjetaDeCirculacion = async () => {
    if (!base64.current[VISIBLE_PREVIEW_ENUM.TARJETA_DE_CIRCULACION]) {
      const values = form.getFieldsValue();
      if (isAlta || isCambio || isRefrendo || isRefrendoReemplacamientoManual) {
        values.marca = values.other;
      }
      const imprimirTarjetaMap = {
        4: imprimirTarjetaDeCirculacionVehiculo,
        16: imprimirTarjetaDeCirculacionMoto,
        17: imprimirTarjetaDeCirculacionRemolque,
      };
      const params = [setLoading, values, vehiculo.id];
      if (tipoDePadronVehicular !== 16 && tipoDePadronVehicular !== 17) {
        params.push(values.unidad_de_recaudacion);
      }
      const file = await imprimirTarjetaMap[tipoDePadronVehicular](...params);
      if (file && tramiteEnProceso && !isCambio) {
        const saved = await finishTramite();
        if (saved) {
          base64.current[VISIBLE_PREVIEW_ENUM.TARJETA_DE_CIRCULACION] = file;
          setVisiblePreview(VISIBLE_PREVIEW_ENUM.TARJETA_DE_CIRCULACION);
        }
      } else {
        base64.current[VISIBLE_PREVIEW_ENUM.TARJETA_DE_CIRCULACION] = file;
        setVisiblePreview(VISIBLE_PREVIEW_ENUM.TARJETA_DE_CIRCULACION);
      }
    } else {
      setVisiblePreview(VISIBLE_PREVIEW_ENUM.TARJETA_DE_CIRCULACION);
    }
  };

  const pasosTramiteCaja = [
    {
      title: 'Trámite',
      description: 'Inicio del Trámite',
      content: <ComenzarTramite />,
    },
    {
      title: 'Pago',
      description: 'Pago de Cargos',
      content: <Pago />,
    },
  ];

  const TarjetaDeCirculacion = () => (
    <>
      {!base64.current[VISIBLE_PREVIEW_ENUM.TARJETA_DE_CIRCULACION] && (
        <>
          <Col span={24}>
            <Form.Item
              name="other"
              label="Marca y Submarca"
              rules={rules.required}
            >
              <Input disabled={tipoDePadronVehicular !== 4} allowClear />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              name="tramite"
              label="Tipo de trámite"
              rules={rules.required}
            >
              <Select
                dataSource={tiposDeTramitesReporteador}
                valueProp="descripcion"
                disabled
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              name="anio"
              label="Periodo"
              rules={rules.required}
            >
              <Select dataSource={[2024, 2025].map((v) => ({ id: v, descripcion: v }))} />
            </Form.Item>
          </Col>
          {(tipoDePadronVehicular !== 16 || tipoDePadronVehicular !== 17) && (
            <Col span={24}>
              <Form.Item
                name="unidad_de_recaudacion"
                label="Unidad Recaudadora"
                rules={rules.required}
              >
                <Select dataSource={unidadesDeRecaudacion} />
              </Form.Item>
            </Col>
          )}
          <Col span={8}>
            <Button block onClick={imprimirTarjetaDeCirculacion}>
              Imprimir tarjeta
            </Button>
          </Col>
        </>
      )}
      {base64.current[VISIBLE_PREVIEW_ENUM.TARJETA_DE_CIRCULACION] && (
        <>
          <Col span={8}>
            <Button block onClick={imprimirTarjetaDeCirculacion}>
              Imprimir tarjeta
            </Button>
          </Col>
          <Col span={8}>
            <Button block onClick={() => getRecibo()}>
              Imprimir recibo
            </Button>
          </Col>
        </>
      )}
    </>
  );

  const pasosPlacasTarjeta = [
    {
      title: 'Placas',
      description: 'Asignación',
      content: <AsignacionDePlacas />,
    },
    {
      title: 'Tarjeta de Circulación',
      description: 'Impresión',
      content: <TarjetaDeCirculacion />,
    },
  ];
  const validateConsiderado = async () => {
    setLoading(true);
    const _propietario = isCambio ? propietarioNuevo : propietario;
    const noAplica = await getMessageConsiderado(_propietario?.id);
    if (noAplica.detail) {
      form.setFieldsValue({
        es_ciudadano_considerado: false,
      });
      setEsConsiderado(false);
      message.info(noAplica.detail, 10);
      setVehiculo({
        ...vehiculo,
        hasDiscount: true,
      });
    } else {
      setEsConsiderado(true);
      form.setFieldsValue({
        es_ciudadano_considerado: true,
      });
      setVehiculo({
        ...vehiculo,
        hasDiscount: false,
      });
    }
    setLoading(false);
  };
  const Considerados = () => (
    <>
      <Col xs={24} sm={24} md={8}>
        <Form.Item label="Considerado" name="es_ciudadano_considerado">
          <Select
            trueFalse
            onChange={(val) => {
              validateConsiderado();
              setEsConsiderado(val);
            }}
            // eslint-disable-next-line max-len
            disabled={isDecreto || isServicioPublico || isBajaDelEstadoVehiculo || vehiculo?.hasDiscount}
          />
        </Form.Item>
      </Col>
      {
        esConsiderado && (
          <Col xs={24} sm={24} md={8}>
            <Form.Item label="Tipo de considerado" name="tipo_de_considerado">
              <Select
                dataSource={tiposDeConsiderado}
                onChange={setTipoDeConsiderado}
                disabled={vehiculo?.hasDiscount}
              />
            </Form.Item>
          </Col>
        )
      }
    </>
  );

  const pasosAlta = [
    {
      title: 'Propietario',
      description: 'Búsqueda/Registro',
      content: <SearchPropietario allowClear={!vehiculo} />,
    },
    {
      title: padronAccent,
      description: 'Registro',
      content: <AddPadronVehicular disabled={!!(tramite || vehiculo)} />,
    },
    tipoDePadronPropietario === 1 && {
      title: 'Considerado',
      description: 'Considerado',
      content: <Considerados />,
    },
    ...pasosTramiteCaja,
    ...pasosPlacasTarjeta,
  ].filter((e, i) => (tipoDePadronPropietario === 1 ? true : i !== 2));

  const pasosCambio = [
    {
      title: 'Propietario Nuevo',
      description: 'Búsqueda/Registro',
      content: <SearchNuevoPropietario allowClear={!vehiculo} />,
    },
    {
      title: padronAccent,
      description: 'Búsqueda',
      content: <AddPadronVehicular disabled={!!(tramite || vehiculo)} />,
    },
    tipoDePadronPropietarioNuevo === 1 && {
      title: 'Considerado',
      description: 'Considerado',
      content: <Considerados />,
    },
    ...pasosTramiteCaja,
    ...pasosPlacasTarjeta,
  ].filter((e, i) => (tipoDePadronPropietarioNuevo === 1 ? true : i !== 2));

  const mapCantidadDePlacasPorPadron = {
    4: 2,
    16: 1,
    17: 1,
  };

  const cantidadesDePlacas = [0, 1, 2].map((e) => ({ label: e, value: e }));
  const cantidadDePlacasRequerida = mapCantidadDePlacasPorPadron[tipoDeTramite
    ?.plantilla_de_tramites?.tipo_de_padron];

  const DatosBaja = () => (
    <>
      <Col span={24} />
      <Col span={8}>
        <Form.Item
          label="Placa"
          name="numero_de_placa"
          rules={rules.required}
          tooltip="Número de placa entregada"
        >
          <Input disabled />
        </Form.Item>
      </Col>
      <Col span={8}>
        <Form.Item
          label="Entidad"
          name="estado"
          rules={rules.required}
        >
          <Select
            dataSource={estados}
            disabled={!isDeOtroEstado}
            labelProp="nombre_de_AGEE"
          />
        </Form.Item>
      </Col>
      <Col span={8}>
        <Form.Item
          label="Recibo"
          name="folio_de_recibo"
          rules={rules.required}
          tooltip="Folio de recibo de pago"
        >
          <Input disabled />
        </Form.Item>
      </Col>
      <Col span={8}>
        <Form.Item
          label="Cantidad de placas"
          name="cantidad_de_placas"
          tooltip="Cantidad de placas entregadas"
        >
          <Select
            dataSource={cantidadesDePlacas}
            allowClear={false}
            labelProp="label"
            valueProp="value"
          />
        </Form.Item>
      </Col>
      {cantidadDePlacas !== cantidadDePlacasRequerida && (
        <Col span={8}>
          <Form.Item
            label="Documento"
            name="folio_de_documento_de_denuncia"
            rules={rules.required}
            tooltip="Folio del documento de denuncia ante la fiscalía"
          >
            <Input allowClear />
          </Form.Item>
        </Col>
      )}
      <SaveButton title="Confirmar baja" icon={<StopOutlined />} danger />
    </>
  );

  const pasosBajaDeOtroEstado = [
    {
      title: 'Propietario',
      description: 'Búsqueda/Registro',
      content: <SearchPropietario allowClear={!vehiculo} />,
    },
    {
      title: 'Registrar',
      description: `${padronVehicularLabel}`,
      content: <AddPadronVehicular disabled={!!vehiculo} />,
    },
    tipoDePadronPropietario === 1 && {
      title: 'Considerado',
      description: 'Considerado',
      content: <Considerados />,
    },
    ...pasosTramiteCaja,
    {
      title: 'Baja',
      description: `Baja ${padronVehicularLabel}`,
      content: (
        <>
          {tramiteEnProceso ? (
            <>
              <Typography.Text>
                Proceda a terminar el proceso de baja
              </Typography.Text>
              <DatosBaja />
            </>
          ) : (
            <>
              {/* TODELETE se quita la validacion cuando vaya para prod porque siempre sera true */}
              <Col span={8}>
                <Button
                  block
                  onClick={() => getFormatoDeDestruccion(true)}
                >
                  Imprimir formato
                </Button>
              </Col>
              <Col span={8}>
                <Button block onClick={() => getRecibo()}>
                  Imprimir recibo
                </Button>
              </Col>
            </>
          )}
        </>
      ),
    },
  ].filter((e, i) => (tipoDePadronPropietario === 1 ? true : i !== 2));

  const pasosBaja = [
    {
      title: padronVehicularLabel,
      description: tramitePortal ? 'Informacion' : 'Búsqueda',
      content: (
        <>
          <SearchVehiculo disabled={!!tramite} searchPadron={searchVehiculoEnAlta} />
          {vehiculo && (<SearchPropietario allowClear={false} />)}
          {vehiculo && !vehiculo?.hasPlacaObject
            && (!(vehiculo?.placa || vehiculo?.numero_de_placa_vigente))
            && (
              <AddPlacaButton />
            )}
        </>
      ),
    },
    tipoDePadronPropietario === 1 && {
      title: 'Considerado',
      description: 'Considerado',
      content: <Considerados />,
    },
    ...pasosTramiteCaja,
    {
      title: 'Baja',
      description: `Baja ${isRefrendo ? 'placa actual' : padronVehicularLabel}`,
      content: (
        <>
          {tramiteEnProceso && (vehiculo?.placa || vehiculo?.numero_de_placa_vigente) ? (
            <>
              {isRefrendo ? (
                <Typography.Text>
                  Al continuar se dará de baja la placa con los siguientes datos:
                </Typography.Text>
              ) : (
                <Typography.Text>
                  Proceda a terminar el proceso de baja
                </Typography.Text>
              )}
              <DatosBaja />
            </>
          ) : (
            <>
              <Col span={8}>
                <Button block onClick={() => getFormatoDeDestruccion(true)}>
                  Imprimir formato
                </Button>
              </Col>
              {!isRefrendo && (
                <Col span={8}>
                  <Button block onClick={() => getRecibo()}>
                    Imprimir recibo
                  </Button>
                </Col>
              )}
            </>
          )}
        </>
      ),
    },
  ].filter((e, i) => (tipoDePadronPropietario === 1 ? true : i !== 1));
  const pasosRefrendoPortal = [
    {
      title: 'Referencia',
      description: 'Busqueda',
      content: <FormItemSearchOrden />,
    },
    pasosBaja[0],
    pasosTramiteCaja[0],
    pasosPlacasTarjeta[1],
  ];

  const pasosReemplacamientoPortal = [
    pasosRefrendoPortal[0],
    pasosBaja[0],
    pasosTramiteCaja[0],
    pasosBaja[tipoDePadronPropietario === 1 ? 4 : 3],
    ...pasosPlacasTarjeta,
  ];

  const _padrones = [{ key: vehiculo?.id?.toString(), cargos: cargosAdeudo }];

  const SeleccionDeAdeudo = () => {
    if (tramite) {
      return (
        <>
          <Folio />
          {tramite.comentarios_del_tramite && (
            <Col span={24} style={{ height: 150, marginTop: 15 }}>
              <Form.Item label="Comentarios" name="comentarios_del_tramite">
                <Input.TextArea disabled autoSize={{ minRows: 4, maxRows: 4 }} />
              </Form.Item>
            </Col>
          )}
          <Col span={8}>
            <Button block onClick={getFormatoTramite}>
              Imprimir formato de trámite
            </Button>
          </Col>
        </>
      );
    }
    const _cargos = sortCargos(recalculateCargos(cargosAdeudo,
      selectedKeys, _padrones, _padrones[0]))
      .sort((a, b) => b.disabled.toString().localeCompare(a.disabled.toString()));
    const total = getTotalPadron(_cargos, selectedKeys);
    return (
      <>
        <Typography.Text>
          Al iniciar el trámite se ligaran los cargos que seleccione a continuación:
        </Typography.Text>
        <Typography.Text style={{ fontSize: 20, marginLeft: 'auto', textAlign: 'right' }}>
          TOTAL A PAGAR:
          {' '}
          {toCurrency(round(total))}
        </Typography.Text>
        <Col span={24} style={{ paddingTop: 10 }}>
          <TableAdeudoPadron
            cargos={_cargos}
            callback={onChangeSelectedKeysAdeudo}
            selectedRowKeys={selectedKeys}
            loading={loadingAdeudo}
            loadingTip={_messageAdeudo}
            tableProps={{
              restHeigth: 50,
              loading: { spinning: loadingAdeudo, tip: _messageAdeudo },
            }}
          />
        </Col>
        <Col span={24} style={{ height: 150, marginTop: 15 }}>
          <Form.Item label="Comentarios" name="comentarios_del_tramite">
            <Input.TextArea autoSize={{ minRows: 4, maxRows: 4 }} />
          </Form.Item>
        </Col>
        <ButtonStartTramite />
      </>
    );
  };

  const pasoSeleccionDeAdeudo = {
    title: 'Adeudo',
    description: 'Selección',
    content: <SeleccionDeAdeudo />,
  };

  const pasoRecibo = {
    title: 'Recibo',
    description: 'Impresión',
    content: (
      <Col span={8}>
        <Button block onClick={() => (tramiteEnProceso ? finishTramite() : getRecibo())}>
          Imprimir recibo
        </Button>
      </Col>
    ),
  };

  const pasosRefrendoActual = [
    pasosBaja[0],
    tipoDePadronPropietario === 1 && {
      title: 'Considerado',
      description: 'Considerado',
      content: <Considerados />,
    },
    pasoSeleccionDeAdeudo,
    pasosTramiteCaja[1],
    pasosPlacasTarjeta[1],
  ].filter((e, i) => (tipoDePadronPropietario === 1 ? true : i !== 1));

  const pasosRefrendoActualManual = [
    pasosBaja[0],
    tipoDePadronPropietario === 1 && {
      title: 'Considerado',
      description: 'Considerado',
      content: <Considerados />,
    },
    ...pasosTramiteCaja,
    pasosPlacasTarjeta[1],
  ].filter((e, i) => (tipoDePadronPropietario === 1 ? true : i !== 1));

  const pasosRefrendoBaja = [
    pasosBaja[0],
    tipoDePadronPropietario === 1 && {
      title: 'Considerado',
      description: 'Considerado',
      content: <Considerados />,
    },
    pasoSeleccionDeAdeudo,
    pasosTramiteCaja[1],
    pasoRecibo,
  ].filter((e, i) => (tipoDePadronPropietario === 1 ? true : i !== 1));

  const pasosRefrendoReemplacamiento = [
    pasosBaja[0],
    tipoDePadronPropietario === 1 && {
      title: 'Considerado',
      description: 'Considerado',
      content: <Considerados />,
    },
    pasoSeleccionDeAdeudo,
    pasosTramiteCaja[1],
    pasosBaja[tipoDePadronPropietario === 1 ? 4 : 3],
    ...pasosPlacasTarjeta,
  ].filter((e, i) => (tipoDePadronPropietario === 1 ? true : i !== 1));

  const pasosRefrendoReemplacamientoManual = [
    pasosBaja[0],
    tipoDePadronPropietario === 1 && {
      title: 'Considerado',
      description: 'Considerado',
      content: <Considerados />,
    },
    ...pasosTramiteCaja,
    pasosBaja[tipoDePadronPropietario === 1 ? 4 : 3],
    ...pasosPlacasTarjeta,
  ].filter((e, i) => (tipoDePadronPropietario === 1 ? true : i !== 1));

  const steps = {
    ...(Object.fromEntries(IDS_TRAMITES.map((id) => {
      if (MAP_IDS_POR_TIPO_DE_TRAMITE.ALTA.includes(id)) {
        return [id, pasosAlta];
      }
      if (MAP_IDS_POR_TIPO_DE_TRAMITE.BAJA.includes(id) && !isDeOtroEstado) {
        return [id, pasosBaja];
      }
      if (MAP_IDS_POR_TIPO_DE_TRAMITE.BAJA.includes(id) && isDeOtroEstado) {
        return [id, pasosBajaDeOtroEstado];
      }
      if (MAP_IDS_POR_TIPO_DE_TRAMITE.CAMBIO.includes(id)) {
        return [id, pasosCambio];
      }
      if (MAP_IDS_POR_TIPO_DE_TRAMITE.REFRENDO.includes(id)) {
        if (isRefrendoPeriodoActual) {
          return [id, pasosRefrendoActual];
        }
        if (isRefrendoPeriodoActualManual) {
          return [id, pasosRefrendoActualManual];
        }
        if (isRefrendoBaja) {
          return [id, pasosRefrendoBaja];
        }
        if (isRefrendoReemplacamiento) {
          return [id, pasosRefrendoReemplacamiento];
        }
        if (isRefrendoReemplacamientoManual) {
          return [id, pasosRefrendoReemplacamientoManual];
        }
        if (tramitePortalReemplacamiento) {
          return [id, pasosReemplacamientoPortal];
        }
        if (tramitePortal) {
          return [id, pasosRefrendoPortal];
        }
      }
      return [];
    }))),
  };

  const currentStepContent = React.useMemo(() => {
    if (tipoDeTramite) {
      return steps[tipoDeTramite.id][currentStep].content;
    }
    return null;
  }, [tipoDeTramite, currentStep, marca, vehiculo?.hasNumeroEconomico, vehiculo?.canContinue,
    vehiculo?.numero_economico, esNacional, propietario, propietarioNuevo, vehiculo,
    vehiculo?.placa, vehiculo?.numero_de_placa_vigente, vehiculo?.hasPlacaObject, tramite,
    versionFound, selectedKeys, tipoDePadronPropietario, tipoDePadronPropietarioNuevo,
    base64.current, visiblePreview, periodosSeleccionados, cantidadDePlacas, esConsiderado,
    configsAsigPlacas, esPlacaDuplicada, permitirPlacaDuplicada, permitirPlacaManual,
    cargosAdeudo, loadingAdeudo, vehiculo?.hasDiscount, ordenPagada, vehiculo?.hasRFC]);

  const getTipoDePadronBusqueda = () => {
    if (visibleBusquedaPropietario || (currentStep === 0 && (isAlta || isDeOtroEstado))) {
      return tipoDePadronPropietario;
    }
    if (visibleBusquedaPropietarioNuevo || (currentStep === 0 && isCambio)) {
      return tipoDePadronPropietarioNuevo;
    }
    return tipoDePadronVehicular;
  };

  const setValuesForStep = async (step) => {
    const valuesPropietario = {
      tipo_de_padron_propietario: tipoDePadronPropietario,
      object_id_propietario: propietario?.id,
    };
    const marcasMap = {
      4: marcasTemp.results.length ? marcasTemp.results : marcas.current.results,
      16: marcasTemp.results.length ? marcasTemp.results : marcas.current.results,
      17: marcasTemp.results.length ? marcasTemp.results : marcas.current.results,
    };

    const _lineasTemp = isVehiculo ? await getLineasVehiculares({ id: vehiculo?.linea })
      : { results: [] };
    const [_lineaAltern] = isVehiculo ? _lineasTemp?.results : [];
    const _linea = marcasMap[tipoDePadronVehicular]
      .find((e) => e.id === vehiculo?.linea) || vehiculo?.linea;
    const _marca = (marcasTemp.results.length ? marcasTemp.results : marcas.current.results)
      .find((e) => e.id === _linea?.marca || vehiculo?.marca);
    const marcaString = `${_marca?.nombre || _marca?.descripcion || ''} ${_linea?.nombre || _linea || ''}`.trim();
    const marcaStringAltern = `${_lineaAltern?.nombre || ''}`.trim();

    const valuesAlta = {
      0: valuesPropietario,
      1: vehiculo,
      4: vehiculo,
      5: { tramite: 'Alta', other: tipoDePadronVehicular === 4 ? marcaStringAltern : marcaString },
    };

    const valuesPropietarioNuevo = {
      tipo_de_padron_propietario: tipoDePadronPropietarioNuevo,
      object_id_propietario_nuevo: propietarioNuevo?.id,
    };

    const valuesCambio = {
      0: valuesPropietarioNuevo,
      1: vehiculo,
      4: vehiculo,
      5: { tramite: 'Cambio de Propietario', other: tipoDePadronVehicular === 4 ? marcaStringAltern : marcaString },
    };

    const valuesBaja = {};
    const valuesBajaPlaca = {
      cantidad_de_placas: mapCantidadDePlacasPorPadron[tipoDeTramite
        ?.plantilla_de_tramites?.tipo_de_padron],
      folio_de_recibo: tramite?.folios,
      numero_de_placa: isRemolque ? vehiculo?.placa : vehiculo?.numero_de_placa_vigente,
      estado: 18,
    };
    if (tramiteEnProceso && !isDeOtroEstado) {
      valuesBaja[3] = valuesBajaPlaca;
    } else {
      if (isDeOtroEstado) {
        delete valuesBajaPlaca.estado;
      }
      valuesBaja[tipoDePadronPropietario === 1 ? 5 : 4] = valuesBajaPlaca;
    }

    const entries = IDS_TRAMITES.map((id) => {
      if (MAP_IDS_POR_TIPO_DE_TRAMITE.ALTA.includes(id)) {
        return [id, valuesAlta];
      }
      if (MAP_IDS_POR_TIPO_DE_TRAMITE.CAMBIO.includes(id)) {
        return [id, valuesCambio];
      }
      if (MAP_IDS_POR_TIPO_DE_TRAMITE.REFRENDO.includes(id)) {
        const valuesRefrendo = {};
        if (isRefrendoPeriodoActual || isRefrendoPeriodoActualManual || tramitePortal) {
          valuesRefrendo[3] = { tramite: 'Refrendo', other: tipoDePadronVehicular === 4 ? marcaStringAltern : marcaString };
        }
        if (isRefrendoReemplacamiento || isRefrendoReemplacamientoManual) {
          valuesRefrendo[tipoDePadronPropietario === 1 ? 4 : 3] = valuesBajaPlaca;
          valuesRefrendo[tipoDePadronPropietario === 1 ? 5 : 4] = vehiculo;
          valuesRefrendo[tipoDePadronPropietario === 1 ? 6 : 5] = { tramite: 'Refrendo', other: tipoDePadronVehicular === 4 ? marcaStringAltern : marcaString };
        }
        if (tramitePortalReemplacamiento) {
          valuesRefrendo[3] = valuesBajaPlaca;
          valuesRefrendo[4] = vehiculo;
          valuesRefrendo[5] = { tramite: 'Refrendo', other: tipoDePadronVehicular === 4 ? marcaStringAltern : marcaString };
        }
        return [id, valuesRefrendo];
      }
      return [id, valuesBaja];
    });
    const map = Object.fromEntries(entries);
    const values = map[tipoDeTramite.id]?.[step];
    if (values) {
      setTimeout(() => form.setFieldsValue(values));
    }
  };

  const next = () => {
    setCurrentStep(currentStep + 1);
    setValuesForStep(currentStep + 1);
  };
  const prev = () => {
    setCurrentStep(currentStep - 1);
    setValuesForStep(currentStep - 1);
  };
  const nextDisabled = () => {
    const padronVehicularHasPlaca = tipoDePadronVehicular === 17
      ? !!vehiculo?.placa : !!(vehiculo?.numero_de_placa_vigente);
    const mapAlta = tipoDePadronPropietario === 1 ? {
      0: !propietario,
      1: !(vehiculo && vehiculo?.canContinue),
      2: !vehiculo,
      3: !tramite,
      4: !tramite?.cargosSaldados,
      5: !padronVehicularHasPlaca,
    } : {
      0: !propietario,
      1: !(vehiculo && vehiculo?.canContinue),
      2: !tramite,
      3: !tramite?.cargosSaldados,
      4: !padronVehicularHasPlaca,
    };

    const mapBaja = tipoDePadronPropietario === 1 ? {
      0: !(vehiculo && propietario && vehiculo?.hasPlacaObject),
      1: !vehiculo, // nuevo considerado
      2: !tramite,
      3: !tramite?.cargosSaldados,
    } : {
      0: !(vehiculo && propietario && vehiculo?.hasPlacaObject),
      1: !tramite,
      2: !tramite?.cargosSaldados,
    };

    const mapBajaDeOtroEstado = tipoDePadronPropietario === 1 ? {
      0: !propietario,
      1: (!vehiculo || !vehiculo?.hasPlacaObject),
      2: !vehiculo, // nuevo considerado
      3: !tramite,
      4: !tramite?.cargosSaldados,
    } : {
      0: !propietario,
      1: (!vehiculo || !vehiculo?.hasPlacaObject),
      2: !tramite,
      3: !tramite?.cargosSaldados,
    };

    const mapCambioPropietario = tipoDePadronPropietarioNuevo === 1 ? {
      0: !propietarioNuevo,
      // eslint-disable-next-line max-len
      1: isCambioServicio ? (!vehiculo || !vehiculo?.hasNumeroEconomico) : (!vehiculo || !vehiculo?.hasRFC),
      2: !vehiculo, // nuevo considerado
      3: !tramite,
      4: !tramite?.cargosSaldados,
      5: !padronVehicularHasPlaca,
    } : {
      0: !propietarioNuevo,
      1: isCambioServicio ? (!vehiculo || !vehiculo?.hasNumeroEconomico) : !vehiculo,
      2: !tramite,
      3: !tramite?.cargosSaldados,
      4: !padronVehicularHasPlaca,
    };
    // const mapRefrendoPortal = tipoDePadronPropietarioNuevo === 1 ? {
    //   0: !ordenPagada,
    //   1: (!vehiculo && !propietario && !padronVehicularHasPlaca)
    //   2: !tramite,
    // };

    const mapReemplacamiento = tipoDePadronPropietario === 1 ? {
      0: (!vehiculo && !propietario && !vehiculo?.hasPlacaObject),
      1: (!vehiculo && !propietario && !vehiculo?.hasPlacaObject), // Paso Considerado
      2: !tramite,
      3: !tramite?.cargosSaldados,
      4: padronVehicularHasPlaca,
      5: !padronVehicularHasPlaca,
    } : {
      0: (!vehiculo && !propietario && !vehiculo?.hasPlacaObject),
      1: !tramite,
      2: !tramite?.cargosSaldados,
      3: padronVehicularHasPlaca,
      4: !padronVehicularHasPlaca,
    };

    const mapRefrendoPortal = {
      0: !ordenPagada,
      1: (!vehiculo && !propietario && !padronVehicularHasPlaca),
      2: !tramite,
      3: true,
    };
    const mapReemplacamientoPortal = {
      0: !ordenPagada,
      1: (!vehiculo && !propietario && !vehiculo?.hasPlacaObject),
      2: !tramite,
      3: padronVehicularHasPlaca,
      4: !padronVehicularHasPlaca,
    };

    const entries = IDS_TRAMITES.map((id) => {
      if (MAP_IDS_POR_TIPO_DE_TRAMITE.ALTA.includes(id)) {
        return [id, mapAlta];
      }
      if (MAP_IDS_POR_TIPO_DE_TRAMITE.BAJA.includes(id)) {
        return [id, isDeOtroEstado ? mapBajaDeOtroEstado : mapBaja];
      }
      if (MAP_IDS_POR_TIPO_DE_TRAMITE.CAMBIO.includes(id)) {
        return [id, mapCambioPropietario];
      }
      if (MAP_IDS_POR_TIPO_DE_TRAMITE.REFRENDO.includes(id)) {
        const mapRefrendo = tipoDePadronPropietario === 1 ? {
          0: (!vehiculo && !propietario && !padronVehicularHasPlaca),
          1: (!vehiculo && !propietario && !padronVehicularHasPlaca),
          2: !tramite,
          3: !tramite?.cargosSaldados,
        } : {
          0: (!vehiculo && !propietario && !padronVehicularHasPlaca),
          1: !tramite,
          2: !tramite?.cargosSaldados,
        };

        if (isRefrendoReemplacamiento || isRefrendoReemplacamientoManual) {
          return [id, mapReemplacamiento];
        }
        if (isRefrendoPeriodoActual || isRefrendoPeriodoActualManual) {
          return [id, mapRefrendo];
        }
        if (tramitePortal) {
          return [id, mapRefrendoPortal];
        }
        if (tramitePortalReemplacamiento) {
          return [id, mapReemplacamientoPortal];
        }
        return [id, mapRefrendo];
      }
      return [];
    });
    const map = Object.fromEntries(entries);
    const disabled = map[tipoDeTramite.id][currentStep];

    return typeof disabled === 'boolean' ? disabled : true;
  };

  const saveTramite = async (_propietario = propietario) => {
    const values = form.getFieldsValue();
    const valuesConsiderado = {
      padron_content_type: getContenTypePorTipoDePadron(tipoDePadronVehicular),
      padron_object_id: vehiculo?.id,
      ciudadano_considerado: isCambio ? propietarioNuevo?.id : propietario?.id,
    };
    const valuesCiudadano = {
      id: isCambio ? propietarioNuevo?.id : propietario?.id,
      es_ciudadano_considerado: esConsiderado,
      tipo_de_considerado: tipoDeConsiderado,
    };
    const requireData = isCambio ? !(propietarioNuevo?.lada || propietarioNuevo?.numero_de_celular)
      : !(_propietario?.lada || _propietario?.numero_de_celular);
    if (requireData && esConsiderado) {
      return setVisibleUpdateData(true);
    }
    if (esConsiderado && tipoDePadronPropietario === 1) {
      const ciudadanoPatched = await patchCiudadano(isCambio ? propietarioNuevo?.id
        : propietario?.id, valuesCiudadano);
      if (!ciudadanoPatched) {
        return false;
      }
      const resConsiderado = await postPadronConsiderado([valuesConsiderado]);
      if (!resConsiderado) {
        return false;
      }
    }
    const isRefrendoVehiculo = isRefrendo && isVehiculo && !isServicioPublico;
    const isRefrendoMoto = isRefrendo && isMoto && !isServicioPublico;
    let _cargos = [];
    if (((isRefrendoVehiculo || isRefrendoMoto)
    && (!tramitePortal && !tramitePortalReemplacamiento))) {
      const mandatoryTypes = getMandatoryTypes();
      const selectedChargeTypes = selectedKeys.map((k) => cargosAdeudo.find((c) => c.id === k))
        .filter((c) => !c.es_accesorio).map((c) => c.tipo_de_cargo.id);
      if (!mandatoryTypes.some((m) => selectedChargeTypes.includes(m))) {
        message.info('No se puede iniciar el trámite sin cargos');
        return false;
      }
      _cargos = selectedKeys;
    } else if ((!tramitePortal && !tramitePortalReemplacamiento)) {
      tipoDeTramite.tiposDeCargos.filter((e) => selectedKeys.includes(e.id)).forEach((tc) => {
        const _cargo = {
          padron: tipoDePadronVehicular,
          padron_id: vehiculo.id,
          tipo_de_cargo: tc.id,
        };
        if (tc.tipo_de_aplicacion === 1) {
          _cargo.importe = values[tc.id].importe;
        }
        if (tc.tipo_de_aplicacion === 2) {
          _cargo.importe = tc.importe;
        }
        // TODO: Por revisar a fondo, nayarit no usa tarifa actualmente
        if (tc.tipo_de_aplicacion === 3 || tc.tipo_de_aplicacion === 5) {
          const [fechaInicial, fechaFinal] = tc.tipo_de_dato === tiposDatosEnum.RANGO_DE_FECHAS
            ? values[tc.id].importe : [];
          const valuesMap = {
            1: values[tc.id].importe,
            2: parseFloat(values[tc.id].importe).toFixed(2),
            3: fechaFinal?.diff(fechaInicial, 'days'),
            5: parseFloat(values[tc.id].importe).toFixed(2),
          };
          _cargo.importe = valuesMap[tc.tipo_de_dato];
        }
        if (tc.tipo_de_aplicacion === 4) {
          _cargo.variables = variables
            .filter((v) => tc.variables.includes(v.id))
            .map((v) => {
              let valor = values[tc.id][v.nombre];
              if (v.tipo_de_variable === 3) {
                const [fechaInicial, fechaFinal] = valor;
                valor = fechaFinal.diff(fechaInicial, 'days');
              }
              return ({
                id: v.id,
                nombre: v.nombre,
                valor,
              });
            });
        }
        _cargos.push(_cargo);
      });
      await checkToken();
      const responses = _cargos.length
        ? await Promise.all(_cargos.map((e) => postGenerarCargos(e))) : [];
      const cargos = responses.flat(2);
      _cargos = cargos.map(mapId);
      const cargosPadres = cargos.filter((c) => c.tipo_de_cargo);
      const cargosPadresIds = cargos.filter((c) => c.tipo_de_cargo).map(mapId);
      if (cargosPadresIds.length !== selectedKeys.length) {
        setCargosGenerados([...cargosGenerados, ...cargos]);
        setSelectedKeys(selectedKeys
          .filter((tc) => !cargosPadres.some((c) => c.tipo_de_cargo.id === tc)));
        return false;
      }
    }
    const valuesTramite = {
      cargos: (tramitePortal || tramitePortalReemplacamiento) ? ordenPagada.cargos.map(mapId)
        : [...cargosGenerados.map(mapId), ..._cargos],
      plantilla: tipoDeTramite.plantilla_de_tramites.id,
      tipo_padron_id: tipoDePadronVehicular,
      content_type_a_padron: getContenTypePorTipoDePadron(tipoDePadronVehicular),
      object_id_padron: vehiculo.id,
      tipos_de_registros_de_tramite: 1,
      estados_globales: 2,
      comentarios_del_tramite: values.comentarios_del_tramite,
      fecha_de_inicio: toMoment(new Date()).format(DATE_FORMAT),
      canal_de_pago: 2,
      es_refrendo: isRefrendo,
      procedencia: 8,
      folio_trm_repuve: folioRepuve,
    };
    const _tipoDeSolicitante = isCambio ? tipoDePadronPropietarioNuevo : tipoDePadronPropietario;
    const solicitante = isCambio ? propietarioNuevo?.id : propietario?.id;
    valuesTramite[_tipoDeSolicitante === 1 ? 'ciudadano' : 'contribuyente'] = solicitante;
    valuesTramite.solicitante_ciudadano = !valuesTramite.contribuyente;
    const _tramite = await postTramite(valuesTramite);
    if (_tramite) {
      const valuesVehiculo = {};
      if (isBaja || isDeOtroEstado) {
        valuesVehiculo.estatus_del_vehiculo = 2;
      }
      if (isRefrendo) {
        valuesVehiculo.estados_globales = 1;
        valuesVehiculo.estatus_del_vehiculo = 1;
      }

      const placaEliminada = valuesVehiculo
        ? await patchVehicularMap[tipoDePadronVehicular](vehiculo.id, valuesVehiculo, false) : true;
      if (placaEliminada) {
        await searchTramite(_tramite.folio, true);
      }
    }
    setLoading(false);
    return false;
  };

  const saveVehiculo = async () => {
    const values = form.getFieldsValue();
    if (tipoDePadronVehicular === 17) {
      values[tipoDePadronPropietario === 1 ? 'ciudadano_propietario' : 'contribuyente_propietario'] = propietario.id;
    } else {
      values[tipoDePadronPropietario === 1 ? 'propietario' : 'contribuyente_propietario'] = propietario.id;
    }
    if (isDeOtroEstado) {
      values.estados_globales = 1;
      values.estatus_del_vehiculo = 1;
    } else {
      values.estados_globales = 2;
      values.estatus_del_vehiculo = 2;
    }
    const postMap = {
      4: postVehiculo,
      16: postMotocicleta,
      17: postRemolque,
    };
    const _vehiculo = await postMap[tipoDePadronVehicular](values);
    if (_vehiculo) {
      setVehiculo({
        ..._vehiculo,
        canContinue: true,
      });
      form.setFieldsValue(_vehiculo);
      message.info(`${padronVehicularLabel} guardado correctamente`);
    }
  };

  const updatePlacas = async (valuesPropietario = {}) => {
    const values = { ...form.getFieldsValue(), ...valuesPropietario };
    values.estados_globales = 1;
    values.estatus_del_vehiculo = 1;
    values.procedente_de_wizard = true;
    values.folio_de_recibo_alta = tramite?.folios;
    values.update_recibo = true;
    if (MAP_IDS_POR_TIPO_DE_TRAMITE.CAMBIO.includes(tipoDeTramite.id)) {
      if (tipoDePadronVehicular === 17) {
        values[tipoDePadronPropietarioNuevo === 1 ? 'ciudadano_propietario' : 'contribuyente_propietario'] = propietarioNuevo.id;
      } else {
        values[tipoDePadronPropietarioNuevo === 1 ? 'propietario' : 'contribuyente_propietario'] = propietarioNuevo.id;
      }
    }

    const _vehiculo = await patchVehicularMap[tipoDePadronVehicular](vehiculo.id, values);
    if (_vehiculo) {
      setVehiculo(_vehiculo);
      if (isCambio
        || isRefrendoReemplacamiento
        || isRefrendoReemplacamientoManual
        || tramitePortalReemplacamiento) {
        const finished = await finishTramite();
        if (finished) {
          base64.current[VISIBLE_PREVIEW_ENUM.RECIBO] = null;
          await getRecibo();
        }
      } else {
        base64.current[VISIBLE_PREVIEW_ENUM.RECIBO] = null;
        await getRecibo();
      }
    }
    return _vehiculo;
  };

  const patchBajaVehicular = async (finish = true, onlyPlaca = false) => {
    const values = form.getFieldsValue();
    const valuesBaja = {
      ...values,
      estatus_del_vehiculo: 2,
      procedente_de_wizard: true,
    };
    if (onlyPlaca) {
      delete valuesBaja.estados_globales;
      delete valuesBaja.estatus_del_vehiculo;
      valuesBaja.dar_baja_placa_por_reemplacamiento = true;
    }
    valuesBaja[tipoDePadronVehicular === 17 ? 'placa' : 'numero_de_placa_vigente'] = null;
    const _vehiculo = await patchVehicularMap[tipoDePadronVehicular](
      vehiculo.id,
      valuesBaja,
      false,
    );
    await getFormatoDeDestruccion(onlyPlaca, values);
    if (onlyPlaca) {
      setVehiculo({
        ...vehiculo,
        hasPlacaObject: false,
        placa: null,
        numero_de_placa_vigente: null,
      });
    }
    if (_vehiculo && finish) {
      const finished = await finishTramite();
      if (finished) {
        base64.current[VISIBLE_PREVIEW_ENUM.RECIBO] = null;
        await getRecibo();
      } else {
        message.warn('No fue posible finalizar el trámite');
      }
    }
  };

  const onFinish = async () => {
    setLoading(true);
    await form.validateFields();
    if (MAP_IDS_POR_TIPO_DE_TRAMITE.ALTA.includes(tipoDeTramite.id)) {
      const onFinishAltaMap = tipoDePadronPropietario === 1 ? {
        1: saveVehiculo,
        3: saveTramite,
        5: updatePlacas,
      } : {
        1: saveVehiculo,
        2: saveTramite,
        4: updatePlacas,
      };
      await onFinishAltaMap[currentStep]();
    }
    if (isDeOtroEstado) {
      const onFinishBajaDeOtroEstadoMap = tipoDePadronPropietario === 1 ? {
        1: saveVehiculo,
        3: saveTramite,
        5: patchBajaVehicular,
      } : {
        1: saveVehiculo,
        2: saveTramite,
        4: patchBajaVehicular,
      };
      await onFinishBajaDeOtroEstadoMap[currentStep]();
    }
    if (MAP_IDS_POR_TIPO_DE_TRAMITE.BAJA.includes(tipoDeTramite.id) && !isDeOtroEstado) {
      const onFinishBajaMap = tipoDePadronPropietario === 1 ? {
        2: saveTramite,
        4: patchBajaVehicular,
      } : {
        1: saveTramite,
        3: patchBajaVehicular,
      };
      await onFinishBajaMap[currentStep]();
    }
    if (MAP_IDS_POR_TIPO_DE_TRAMITE.CAMBIO.includes(tipoDeTramite.id)) {
      const onFinishCambioMap = tipoDePadronPropietarioNuevo === 1 ? {
        3: saveTramite,
        5: updatePlacas,
      } : {
        2: saveTramite,
        4: updatePlacas,
      };
      await onFinishCambioMap[currentStep]();
    }
    if (MAP_IDS_POR_TIPO_DE_TRAMITE.REFRENDO.includes(tipoDeTramite.id)) {
      const onFinishMap = tipoDePadronPropietario === 1 || tramitePortal
      || tramitePortalReemplacamiento ? {
          2: saveTramite,
        } : {
          1: saveTramite,
        };
      if (isRefrendoReemplacamiento || isRefrendoReemplacamientoManual) {
        onFinishMap[tipoDePadronPropietario === 1 ? 4 : 3] = () => patchBajaVehicular(false, true);
        onFinishMap[tipoDePadronPropietario === 1 ? 5 : 4] = updatePlacas;
      }
      if (tramitePortalReemplacamiento) {
        onFinishMap[3] = () => patchBajaVehicular(false, true);
        onFinishMap[4] = updatePlacas;
      }
      await onFinishMap[currentStep]();
    }
    setLoading(false);
  };

  const getRequirements = (_tipoDeTramite) => {
    const plantilla = _tipoDeTramite.plantilla_de_tramites;
    const contentType = plantilla?.content_type_tramite;
    const tipoDePadron = plantilla?.tipo_de_padron;
    const gratuito = plantilla?.es_tramite_gratuito;
    const conditions = [
      {
        condition: !plantilla,
        text: 'no hay plantilla de trámite relacionada',
      },
      {
        condition: plantilla && !contentType,
        text: 'la plantilla de trámite no tiene content type',
      },
      {
        condition: plantilla && !plantilla.formato_para_folio,
        text: 'la plantilla de trámite no tiene formato de folio asignado',
      },
      {
        condition: plantilla && !plantilla.tipo_de_padron,
        text: 'la plantilla de trámite no tiene tipo de padrón',
      },
      {
        condition: (!gratuito && !_tipoDeTramite.tiposDeCargos.length),
        text: 'no hay tipos de cargos configurados en el cargo vehicular',
      },
      {
        condition: (tipoDePadron && !padronesVehiculares.map(mapId).includes(tipoDePadron))
          || (contentType && !padronesVehiculares.map((e) => e.content_type).includes(contentType))
          || !IDS_TRAMITES_SOPORTADOS.includes(_tipoDeTramite.id),
        text: 'tipo de trámite no soportado',
      },
    ];
    const conditionsNotPassed = conditions.filter((e) => e.condition);
    const str = listToString(conditionsNotPassed.map((e) => e.text));
    return str.toUpperCase();
  };

  const tiposDeTramitesFiltered = tiposDeTramites
    .filter((tipo) => tipo.plantilla_de_tramites?.tipo_de_padron === tipoDePadronFilter);

  const SeleccionDeTipoDeTramite = () => (tipoDePadronFilter ? (
    <>
      <br />
      <Row justify="space-between">
        <Typography.Title level={2} className="primary-text" style={{ width: 'auto' }}>
          Trámites
          {' '}
          {padronesVehiculares.find((p) => p.id === tipoDePadronFilter)?.descripcion}
        </Typography.Title>
        <Button onClick={() => setTipoDePadronFilter()} type="link">
          <ArrowLeftOutlined />
          Regresar
        </Button>
      </Row>
      <Row gutter={[10, 10]}>
        {tiposDeTramitesFiltered.map((tipo) => {
          const requirements = getRequirements(tipo);
          return (
            <Col span={8} key={tipo.id}>
              <Tooltip
                title={requirements}
                overlayInnerStyle={{ fontWeight: 'bold' }}
                color={theme.primaryText}
              >
                <ButtonTramite
                  className={requirements && 'disabled'}
                  onClick={() => {
                    if (!requirements) {
                      localStorage.setItem('tipoDeTramite', JSON.stringify(tipo));
                      setTipoDeTramite(tipo);
                      if (!MAP_IDS_POR_TIPO_DE_TRAMITE.REFRENDO.includes(tipo.id)) {
                        const periodoFiscalVigente = periodosFiscales
                          .find((e) => e.vigente)?.id;
                        setSelectedKeys(tipo.tiposDeCargos
                          .filter((e) => e.periodo_fiscal === periodoFiscalVigente)
                          .map((e) => e.id));
                      }
                      setTipoDePadronVehicular(tipo.plantilla_de_tramites.tipo_de_padron);
                    }
                  }}
                  block
                >
                  {tipo.descripcion}
                  {requirements && (
                    <QuestionCircleOutlined />
                  )}
                </ButtonTramite>
              </Tooltip>
            </Col>
          );
        })}
      </Row>
    </>
  ) : (
    <>
      <Typography.Title style={{ marginTop: 30 }} level={2} className="primary-text">
        Consulta de Trámite
      </Typography.Title>
      <Form layout="vertical" form={form}>
        <FormItemSearchTramite />
      </Form>
      <Typography.Title level={2} className="primary-text">
        Padrones Vehículares
      </Typography.Title>
      <Row gutter={[10, 10]}>
        {padronesVehiculares.map((padron) => (
          <Col span={8} key={padron.id}>
            <ButtonTramite
              onClick={() => setTipoDePadronFilter(padron.id)}
              block
            >
              {padron.descripcion}
            </ButtonTramite>
          </Col>
        ))}
      </Row>
    </>
  ));

  const _propietario = propietarioNuevo || propietario;
  const validationStepPlacaAlta = isAlta && tipoDePadronPropietario === 1
    ? currentStep === 5 : currentStep === 4;

  const validationStepPlacaCambio = isCambio && tipoDePadronPropietarioNuevo === 1
    ? currentStep === 5 : currentStep === 4;

  const msgConfirmacion = () => (
    message.info({
      content: (
        <>
          <Row justify="center">
            <strong style={{ marginRight: 3 }}>
              Estás a punto de confirmar el trámite.
            </strong>
          </Row>
          <Row justify="center">
            <strong style={{ marginRight: 3 }}>
              ¿Estás seguro que toda la información es correcta?
            </strong>
          </Row>
          <Row justify="center">
            <strong style={{ marginRight: 3 }}>
              Una vez confirmado este mensaje no sera posible editar el trámite.
            </strong>
          </Row>
          <Row align="middle" justify="center" style={{ width: '100%' }}>
            <Button
              type="link"
              onClick={() => onFinish()}
            >
              Si
            </Button>
            <Button
              onClick={() => {
                message.destroy();
              }}
              type="link"
            >
              No
            </Button>
          </Row>
        </>
      ),
      duration: 0,
    })
  );
  const fallbackCambio = isCambio && tramiteEnProceso;

  const fallbackReemplacamiento = isRefrendoReemplacamiento && tramiteEnProceso
  && vehiculo[tipoDePadronVehicular === 17 ? 'placa' : 'numero_de_placa_vigente'];

  const fallbackReemplacamientoPortal = tramitePortalReemplacamiento && tramiteEnProceso
  && vehiculo[tipoDePadronVehicular === 17 ? 'placa' : 'numero_de_placa_vigente'];

  const stepPatchBaja = isBaja && tipoDePadronPropietario === 1
    ? currentStep === 4 : currentStep === 3;

  const stepPatchBajaDeOtroEstado = isDeOtroEstado && tipoDePadronPropietario === 1
    ? currentStep === 5 : currentStep === 4;

  const needFolio = /(alta)|(cambio de propietario)|(placas)/i.test(tipoDeTramite?.descripcion);

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <Spin tip="Cargando..." spinning={loading}>
        <Container>
          <Button type="link" onClick={() => history.push('/dashboard')}>
            <HomeOutlined />
            Ir al Dashboard
          </Button>
          {tipoDeTramite ? (
            <>
              <Row justify="space-between">
                <Typography.Title
                  level={2}
                  className="primary-text"
                  style={{ width: `calc(100% - ${125 + (tramiteEnProceso ? 125 : 0)}px)` }}
                >
                  {tipoDeTramite.descripcion}
                  {_propietario && ' - '}
                  {_propietario && getNombreCompleto(_propietario)}
                  {_propietario && vehiculo && ' - '}
                  {vehiculo && (vehiculo.serie || vehiculo.numero_de_identificacion_vehicular)}
                  {tramite?.estados_globales === 5 ? ' - Trámite Cancelado' : null}
                </Typography.Title>
                <Space>
                  {(fallbackCambio
                  || fallbackReemplacamiento
                  || fallbackReemplacamientoPortal
                  || (tramiteEnProceso && !isCambio
                    && (!isRefrendoReemplacamiento
                      || !isRefrendoReemplacamientoManual
                      || !tramitePortalReemplacamiento
                    ))) && (
                      <Button onClick={() => setVisibleCancelar(true)} type="link" danger className="no-color">
                        <StopOutlined />
                        Cancelar
                      </Button>
                  )}
                  <Button onClick={onCancel} type="link">
                    <ArrowLeftOutlined />
                    Regresar
                  </Button>
                </Space>
              </Row>
              <Row justify="space-between" style={{ padding: '15px 30px' }}>
                <Button
                  type="link"
                  disabled={currentStep === 0}
                  onClick={() => prev()}
                  style={{ fontSize: 20 }}
                >
                  <ArrowLeftOutlined />
                  Anterior
                </Button>
                <Button
                  type="link"
                  onClick={() => next()}
                  disabled={nextDisabled()}
                  style={{ fontSize: 20 }}
                >
                  Siguiente
                  <ArrowRightOutlined />
                </Button>
              </Row>
              <Steps progressDot size="small" current={currentStep}>
                {steps[tipoDeTramite.id].map((item) => (
                  <Steps.Step key={item.title} title={item.title} description={item.description} />
                ))}
              </Steps>
              <StepsContent>
                <Form
                  layout="vertical"
                  form={form}
                  initialValues={{
                    metodo_busqueda: 1,
                    tipo_de_padron_propietario: 1,
                    tipo_de_padron_propietario_nuevo: 1,
                    tipo_de_padron_vehicular: 4,
                    tipo_de_combustible: 1,
                    cilindraje: 4,
                    numero_de_puertas: 4,
                    servicio: 1,
                    estatus_del_vehiculo: 2,
                    tipo_de_tenencia_vehicular: tenencias[0]?.id,
                    periodos_seleccionados: [],
                    es_vehiculo_nacional: true,
                    permitirPlacaDuplicada: false,
                    es_ciudadano_considerado: false,
                  }}
                  onValuesChange={(changedValues) => {
                    if ('numero_de_placa_vigente' in changedValues && !changedValues.numero_de_placa_vigente) {
                      setEsPlacaDuplicada(false);
                    } else if ('placa' in changedValues && !changedValues.placa) {
                      setEsPlacaDuplicada(false);
                    }
                  }}
                  onFinish={() => {
                    if (isRefrendo || useAutoAssing) {
                      msgConfirmacion();
                      return;
                    }
                    if ((validationStepPlacaAlta || validationStepPlacaCambio)
                      && !permitirPlacaDuplicada
                      && !isDeOtroEstado && !isBaja) {
                      validarPlacaDuplicada(msgConfirmacion);
                    } else if (
                      (stepPatchBajaDeOtroEstado && isDeOtroEstado)
                    || (stepPatchBaja && isBaja)) {
                      msgConfirmacion();
                    } else {
                      onFinish();
                    }
                  }}
                  scrollToFirstError
                >
                  <Row gutter={10}>
                    {/* TOFIX: esto povocaba que al seleccionar en un select
                     se hiciera render y se perdiera el state de el select y el hook,
                     se soluciono temporalmente con un parche para evitar los renders,
                     checar despues :D */}
                    {/* {steps[tipoDeTramite.id][currentStep].content} */}
                    {currentStepContent}
                    {needFolio && !tramite && currentStep === 0 && (
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          label="Folio de trámite REPUVE"
                          name="folio_trm_repuve"
                          // rules={rules.required}
                        >
                          <Input onChange={({ target: { value } }) => setFolioRepuve(value)} />
                        </Form.Item>
                      </Col>
                    )}
                  </Row>
                </Form>
              </StepsContent>
            </>
          ) : (
            <SeleccionDeTipoDeTramite />
          )}
        </Container>
      </Spin>
      <WidgetPlaca
        visible={visiblePlaca}
        setVisible={setVisiblePlaca}
        vehiculoId={vehiculo?.id}
        padronVehicular={tipoDePadronVehicular}
        callback={(_vehiculo, _placa) => {
          setVehiculo({
            ...vehiculo,
            [tipoDePadronVehicular === 17
              ? 'placa' : 'numero_de_placa_vigente']: _placa?.numero_de_placa,
            hasPlacaObject: true,
          });
          form.setFieldsValue({
            [tipoDePadronVehicular === 17
              ? 'placa' : 'numero_de_placa_vigente']: _placa?.numero_de_placa,
          });
        }}
        message="Es necesario agregar la placa al padrón para continuar con el trámite"
      />
      <WidgetServicioPublico
        visible={visibleWidget}
        setVisible={setVisibleWidget}
        vehiculoId={vehiculo?.id}
        callback={(_vehiculo) => {
          setVehiculo({
            ...vehiculo,
            hasNumeroEconomico: true,
          });
          form.setFieldsValue({
            servicio: _vehiculo?.servicio,
            numero_economico: _vehiculo?.numero_economico,
            uso_del_vehiculo: _vehiculo?.uso_del_vehiculo,
          });
        }}
        message="Es necesario agregar estos campos al padrón para continuar con el trámite"
      />
      <WidgetRfcEmisor
        visible={visibleWidgetRFC}
        setVisible={setVisibleWidgetRFC}
        vehiculoId={vehiculo?.id}
        tipoDePadronVehicular={tipoDePadronVehicular}
        callback={(_vehiculo) => {
          setVehiculo({
            ...vehiculo,
            hasRFC: true,
          });
          form.setFieldsValue({
            rfc_emisor_cdfi: _vehiculo?.rfc_emisor_cdfi,
          });
        }}
        message="Es necesario agregar el RFC del Emisor al padrón para continuar con el trámite"
      />
      <BusquedaAvanzadaPadrones
        visible={visibleBusquedaPropietario || visibleBusquedaPropietarioNuevo
          || visibleBusquedaVehiculo}
        setVisible={() => {
          setVisibleBusquedaPropietarioNuevo(false);
          setVisibleBusquedaPropietario(false);
          setVisibleBusquedaVehiculo(false);
        }}
        callback={async (record) => {
          if (visibleBusquedaPropietario && record.fromThisEntity !== false) {
            setPropietario(record);
            form.setFieldsValue({ object_id_propietario: record.id });
          }
          if (visibleBusquedaPropietarioNuevo && record.fromThisEntity !== false) {
            setPropietarioNuevo(record);
            form.setFieldsValue({ object_id_propietario_nuevo: record.id });
          }
          if (visibleBusquedaVehiculo) {
            await validateTramiteEnProceso(record, tipoDePadronVehicular, async () => {
              if (MAP_IDS_POR_TIPO_DE_TRAMITE.REFRENDO.includes(tipoDeTramite.id)
                || MAP_IDS_POR_TIPO_DE_TRAMITE.BAJA.includes(tipoDeTramite.id)) {
                await searchVehiculoEnAlta(record.id);
              } else {
                await searchVehiculoEnBaja(record.id);
              }
            });
          }
        }}
        tipoDePadron={getTipoDePadronBusqueda()}
        dataExterno={[]}
        allowAdd
        allowEdit
        isBajaDeOtroEstado={isDeOtroEstado}
      />
      <Previewer
        visible={Boolean(base64.current[visiblePreview])}
        setVisible={() => setVisiblePreview()}
        base64={base64.current[visiblePreview]}
      />
      <ModalCancelarTramite
        tramite={tramite?.id}
        setVisible={setVisibleCancelar}
        visible={visibleCancelar}
        cancelarPadron={isAlta}
        cancelarCargos={!isRefrendo || isRefrendoPeriodoActualManual}
        esRefrendo={isRefrendo}
        tramiteDePortal={tramitePortal || tramitePortalReemplacamiento}
        callback={async () => {
          if (isBaja && !isRefrendo) {
            const values = {
              estatus_del_vehiculo: 1,
            };
            const patched = await patchVehicularMap[tipoDePadronVehicular](vehiculo?.id, values);
            if (patched) {
              message.info('Cancelado Correctamente');
            }
          }
          if (isAlta) {
            const values = {
              estatus_del_vehiculo: 2,
            };
            if (values?.[tipoDePadronVehicular === 17 ? 'placa' : 'numero_de_placa_vigente']) {
              values[tipoDePadronVehicular === 17 ? 'placa' : 'numero_de_placa_vigente'] = null;
              values.procedente_de_wizard = true;
              values.cantidad_de_placas = mapCantidadDePlacasPorPadron[tipoDeTramite
                ?.plantilla_de_tramites?.tipo_de_padron];
              values.folio_de_recibo = tramite?.folios;
              values.numero_de_placa = isRemolque
                ? vehiculo?.placa : vehiculo?.numero_de_placa_vigente;
              values.estado = 18;
              delete values.propietario;

              const patched = await patchVehicularMap[tipoDePadronVehicular](vehiculo?.id, values);
              if (patched) {
                message.info('Cancelado Correctamente');
              }
            }
          }
          onCancel();
        }}
      />
      <BusquedaAvanzadaVersion
        visible={visibleBusquedaVersiones}
        setVisible={setVisibleBusquedaVersiones}
        callback={fetchVersion}
        dataExterno={dataExternoVersiones}
        setDataExterno={setDataExternoVersiones}
      />
      <UpdateCiudadano
        ciudadano={isCambio ? propietarioNuevo?.id : propietario?.id}
        visible={visibleUpdateData}
        setVisible={setVisibleUpdateData}
        callback={async (updated) => {
          if (isCambio) {
            setPropietarioNuevo(updated);
          } else {
            setPropietario(updated);
          }
          await saveTramite(updated);
        }}
      />
    </ThemeProvider>
  );
};

const Container = styled.div`
          height: 100vh;
          overflow: hidden scroll;
          padding: 20px 30px;
          .ant-form-item-control-input-content,
          .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
            height: 36px;
  }
          .ant-form-item-label label,
          .ant-select-selection-item,
          .ant-input {
            font - size: 16px;
  }
          .ant-form-item-control-input-content,
          .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
            height: 36px;
  }

  .ant-steps-item-finish>.ant-steps-item-container>.ant-steps-item-tail:after {
            background - color: ${({ theme }) => theme.activeBackgroundColor};
  }
  .ant-steps-item-finish .ant-steps-item-icon>.ant-steps-icon .ant-steps-icon-dot {
            background: ${({ theme }) => theme.activeBackgroundColor};
  }
  .ant-steps-item-process .ant-steps-item-icon>.ant-steps-icon .ant-steps-icon-dot {
            background: ${({ theme }) => theme.activeBackgroundColor};
  }
          `;

const ButtonTramite = styled(Button).attrs({ className: 'no-color' })`
          height: 80px;
          background: ${({ theme }) => theme.backgroundColor};
          color: ${({ theme }) => theme.color};
          border-radius: 12px;
          white-space: break-spaces;
          :not(:disabled):not(.disabled) {
    :focus, :hover, :active {
            background: ${({ theme }) => theme.backgroundColor};
          color: ${({ theme }) => theme.color} !important;
          opacity: 0.8;
    }
  }
          `;

const StepsContent = styled.div`
          background-color: #fafafa;
          border: 1px dashed #e9e9e9;
          border-radius: 2px;
          height: calc(100vh - 270px);
          overflow: hidden scroll;
          padding: 20px;
          `;

export default TramitesVehiculares;
